// ============================================
// JURISDICTION DETECTION & CALCULATION HELPERS
// ============================================

/**
 * Detect jurisdiction based on address string
 * @param {string} address - Property address
 * @returns {'palo_alto' | 'los_altos_hills' | 'los_altos' | 'unknown'}
 */
export const detectJurisdiction = (address) => {
    if (!address) return 'unknown';
    const addr = address.toLowerCase();

    // Check for Palo Alto first (more specific matching)
    if (addr.includes('palo alto')) {
        return 'palo_alto';
    }
    // Check for Los Altos Hills (must check before Los Altos)
    if (addr.includes('los altos hills')) {
        return 'los_altos_hills';
    }
    // Check for Los Altos (general)
    if (addr.includes('los altos')) {
        return 'los_altos';
    }
    // Check for Saratoga
    if (addr.includes('saratoga')) {
        return 'saratoga';
    }
    // Check for Los Gatos
    if (addr.includes('los gatos')) {
        return 'los_gatos';
    }
    // Check for Monte Sereno
    if (addr.includes('monte sereno')) {
        return 'monte_sereno';
    }
    // Check for Cupertino Hillside
    if (addr.includes('cupertino hillside')) {
        return 'cupertino_hillside';
    }
    // Check for Cupertino
    if (addr.includes('cupertino')) {
        return 'cupertino';
    }
    // Check for San Jose
    if (addr.includes('san jose')) {
        return 'san_jose';
    }
    // Check for Fremont
    if (addr.includes('fremont')) {
        return 'fremont';
    }
    // Check for Hillsborough
    if (addr.includes('hillsborough')) {
        return 'hillsborough';
    }
    // Check for Atherton
    if (addr.includes('atherton')) {
        return 'atherton';
    }
    // Check for Woodside
    if (addr.includes('woodside')) {
        return 'woodside';
    }
    // Check for Redwood City
    if (addr.includes('redwood city')) {
        return 'redwood_city';
    }
    // Check for San Mateo
    if (addr.includes('san mateo')) {
        return 'san_mateo';
    }
    // Check for Daly City
    if (addr.includes('daly city')) {
        return 'daly_city';
    }
    // Check for South San Francisco
    if (addr.includes('south san francisco')) {
        return 'south_san_francisco';
    }
    // Check for Foster City
    if (addr.includes('foster city')) {
        return 'foster_city';
    }
    // Check for Burlingame
    if (addr.includes('burlingame')) {
        return 'burlingame';
    }
    // Check for Belmont
    if (addr.includes('belmont')) {
        return 'belmont';
    }
    // Check for San Carlos
    if (addr.includes('san carlos')) {
        return 'san_carlos';
    }
    // Check for Menlo Park
    if (addr.includes('menlo park')) {
        return 'menlo_park';
    }
    // Check for Millbrae
    if (addr.includes('millbrae')) {
        return 'millbrae';
    }
    // Check for Pacifica
    if (addr.includes('pacifica')) {
        return 'pacifica';
    }
    // Check for Half Moon Bay
    if (addr.includes('half moon bay')) {
        return 'half_moon_bay';
    }
    // Check for Orinda
    if (addr.includes('orinda')) {
        return 'orinda';
    }
    // Check for Lafayette
    if (addr.includes('lafayette')) {
        return 'lafayette';
    }
    // Check for Mountain View
    if (addr.includes('mountain view')) {
        return 'mountain_view';
    }
    // Check for Sunnyvale
    if (addr.includes('sunnyvale')) {
        return 'sunnyvale';
    }
    // Check for Santa Clara
    if (addr.includes('santa clara')) {
        return 'santa_clara';
    }
    // Check for Milpitas
    if (addr.includes('milpitas')) {
        return 'milpitas';
    }
    // Check for Campbell
    if (addr.includes('campbell')) {
        return 'campbell';
    }
    // Check for Gilroy
    if (addr.includes('gilroy')) {
        return 'gilroy';
    }
    // Check for Morgan Hill
    if (addr.includes('morgan hill')) {
        return 'morgan_hill';
    }
    // Check for Walnut Creek
    if (addr.includes('walnut creek')) {
        return 'walnut_creek';
    }
    // Check for Concord
    if (addr.includes('concord')) {
        return 'concord';
    }
    // Check for Richmond
    if (addr.includes('richmond')) {
        return 'richmond';
    }
    // Check for Antioch
    if (addr.includes('antioch')) {
        return 'antioch';
    }
    // Check for Brentwood
    if (addr.includes('brentwood')) {
        return 'brentwood';
    }
    // Check for Pittsburg
    if (addr.includes('pittsburg')) {
        return 'pittsburg';
    }
    // Check for San Ramon
    if (addr.includes('san ramon')) {
        return 'san_ramon';
    }
    // Check for Pleasant Hill
    if (addr.includes('pleasant hill')) {
        return 'pleasant_hill';
    }
    if (addr.includes('clayton')) {
        return 'clayton';
    }
    if (addr.includes('moraga')) {
        return 'moraga';
    }
    if (addr.includes('danville')) {
        return 'danville';
    }
    if (addr.includes('alamo')) {
        return 'alamo';
    }
    // Check for Martinez
    if (addr.includes('martinez')) {
        return 'martinez';
    }
    // Check for El Cerrito
    if (addr.includes('el cerrito')) {
        return 'el_cerrito';
    }
    // Check for Hercules
    if (addr.includes('hercules')) {
        return 'hercules';
    }
    // Check for Pinole
    if (addr.includes('pinole')) {
        return 'pinole';
    }
    // Check for Oakland
    if (addr.includes('oakland')) {
        return 'oakland';
    }
    // Check for Alameda
    if (addr.includes('alameda')) {
        return 'alameda';
    }
    // Check for Berkeley
    if (addr.includes('berkeley') || addr.includes('barkeley')) {
        return 'berkeley';
    }
    // Check for Hayward
    if (addr.includes('hayward')) {
        return 'hayward';
    }
    // Check for Livermore
    if (addr.includes('livermore')) {
        return 'livermore';
    }
    // Check for Pleasanton
    if (addr.includes('pleasanton')) {
        return 'pleasanton';
    }
    // Check for Dublin
    if (addr.includes('dublin')) {
        return 'dublin';
    }
    // Check for Newark
    if (addr.includes('newark')) {
        return 'newark';
    }
    // Check for Union City
    if (addr.includes('union city') || addr.includes('unioncity')) {
        return 'union_city';
    }
    // Check for San Leandro
    if (addr.includes('san leandro') || addr.includes('sanleandro')) {
        return 'san_leandro';
    }
    // Check for Emeryville
    if (addr.includes('emeryville')) {
        return 'emeryville';
    }
    // Check for Albany
    if (addr.includes('albany')) {
        return 'albany';
    }
    // Check for Piedmont
    if (addr.includes('piedmont')) {
        return 'piedmont';
    }
    // Check for Portola Valley
    if (addr.includes('portola valley')) {
        return 'portola_valley';
    }
    // Check for Marin Cities
    if (addr.includes('belvedere')) return 'belvedere';
    if (addr.includes('corte madera')) return 'corte_madera';
    if (addr.includes('fairfax')) return 'fairfax';
    if (addr.includes('larkspur')) return 'larkspur';
    if (addr.includes('mill valley')) return 'mill_valley';
    if (addr.includes('novato')) return 'novato';
    if (addr.includes('ross')) return 'ross';
    if (addr.includes('san anselmo')) return 'san_anselmo';
    if (addr.includes('san rafael')) return 'san_rafael';
    if (addr.includes('sausalito')) return 'sausalito';
    if (addr.includes('tiburon')) return 'tiburon';
    // Check for Oakley and San Pablo
    if (addr.includes('oakley')) return 'oakley';
    if (addr.includes('san pablo')) return 'san_pablo';

    // Fallback: Detect County if city is not found
    if (addr.includes('santa clara county') || addr.includes(', scc') || addr.includes('santaclara county')) {
        return 'scc_generic';
    }
    if (addr.includes('alameda county') || addr.includes(', alameda')) {
        // Note: Alameda is also a city, but if it didn't match 'alameda' (city) above,
        // it might be the county mention at the end.
        return 'alameda_generic';
    }
    if (addr.includes('marin county') || addr.includes(', marin')) {
        return 'marin_generic';
    }
    // Check for Napa Cities
    if (addr.includes('american canyon')) return 'american_canyon';
    if (addr.includes('calistoga')) return 'calistoga';
    if (addr.includes('napa')) return 'napa';
    if (addr.includes('st helena') || addr.includes('st. helena')) return 'st_helena';
    if (addr.includes('yountville')) return 'yountville';
    if (addr.includes('napa county') || addr.includes(', napa')) return 'napa_generic';
    // Check for Solano Cities
    if (addr.includes('benicia')) return 'benicia';
    if (addr.includes('dixon')) return 'dixon';
    if (addr.includes('fairfield')) return 'fairfield';
    if (addr.includes('rio vista')) return 'rio_vista';
    if (addr.includes('suisun city')) return 'suisun_city';
    if (addr.includes('vacaville')) return 'vacaville';
    if (addr.includes('vallejo')) return 'vallejo';
    if (addr.includes('solano county') || addr.includes(', solano')) return 'solano_generic';
    // Check for Calaveras County / Arnold
    if (addr.includes('arnold')) return 'arnold';
    if (addr.includes('calaveras county') || addr.includes(', calaveras')) return 'calaveras_generic';
    if (addr.includes('frisco')) return 'frisco';
    if (addr.includes('mckinney')) return 'mckinney';

    return 'unknown';
};

/**
 * Get jurisdiction display name and code reference
 */
export const getJurisdictionInfo = (jurisdiction) => {
    switch (jurisdiction) {
        case 'palo_alto':
            return {
                name: 'Palo Alto',
                code: 'PAMC 18.16.090',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 20,
                description: 'Slope density formula applies when slope > 20%'
            };
        case 'los_altos_hills':
            return {
                name: 'Los Altos Hills',
                code: 'LAH Municipal Code',
                county: 'SCC',
                usesLuf: true,
                slopeThreshold: null,
                description: 'Uses Lot Unit Factor (LUF) for calculations'
            };
        case 'los_altos':
            return {
                name: 'Los Altos',
                code: 'Los Altos Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Slope formula S = 0.0023 * I * L / A applies. Tiered FAR (45/40/35%) based on lot size.'
            };
        case 'saratoga':
            return {
                name: 'Saratoga',
                code: 'Saratoga Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                mdaLabel: 'Site Coverage',
                mfaLabel: 'Floor Area Allowance',
                description: 'Slope formula S = 0.002296 * I * L / A applies. Net Site Area reductions when slope > 10%.'
            };
        case 'los_gatos':
            return {
                name: 'Los Gatos',
                code: 'Los Gatos Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                mdaLabel: null,
                mfaLabel: 'Maximum Allowed Gross Floor Area',
                description: 'Table 2 Floor Area rules applies. Net Site Area reductions when slope > 10%.'
            };
        case 'monte_sereno':
            return {
                name: 'Monte Sereno',
                code: 'Monte Sereno Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                mdaLabel: 'Maximum Structural Coverage',
                mfaLabel: 'Maximum Size of Main Dwelling Unit',
                description: 'Slope Density Formula applies for slope >= 10%. Impervious coverage adjustments apply.'
            };
        case 'cupertino':
            return {
                name: 'Cupertino',
                code: 'Cupertino Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                mdaLabel: 'Lot Coverage',
                mfaLabel: 'Maximum Allowable Floor Area',
                description: 'R-1 Zone: 45% FAR.'
            };
        case 'cupertino_hillside':
            return {
                name: 'Cupertino Hillside (RHS)',
                code: 'Cupertino Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                mdaLabel: 'Lot Coverage',
                mfaLabel: 'Maximum Allowable Floor Area',
                description: 'RHS Zone: Slope reduction (1.5% per 1% slope > 10%). MDA: 45% of net lot area.'
            };
        case 'san_jose':
            return {
                name: 'San Jose',
                code: 'San Jose Zoning Ordinance',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 30,
                description: 'MDA: 40% of lot area. FAR: 45%. CDP required if slope >= 30%.'
            };
    case 'fremont':
            return {
                name: 'Fremont',
                code: 'Fremont Municipal Code Title 18',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 6,
                description: 'Hillside Combining District (H-I) rules applies for slope > 6%. Reduction in building area applies.'
            };
        case 'hillsborough':
            return {
                name: 'Hillsborough',
                code: 'Hillsborough Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 20,
                description: 'FAR: 25% for 1st acre, 15% thereafter. Min 2,500 sq ft. CDP may apply > 20%.'
            };
        case 'atherton':
            return {
                name: 'Atherton',
                code: 'Atherton Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: null,
                mdaLabel: 'Maximum Building Footprint',
                mfaLabel: 'Maximum Floor Area',
                description: 'MFA based on lot size (e.g. 18% if >= 1 acre). Footprint coverage cap 40%.'
            };
        case 'woodside':
            return {
                name: 'Woodside',
                code: 'Woodside Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 12.5,
                mdaLabel: 'Maximum Paved Area',
                mfaLabel: 'Max Main Residence Size',
                description: 'R-1: 5,217 * (Acres - 0.458) + 3,000 sq ft. Slope review at 12.5%.'
            };
        case 'redwood_city':
            return {
                name: 'Redwood City',
                code: 'Redwood City Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'FAR: 40% (min 2,500 sq ft). Review required if MFA > 45% or 3,000 sq ft. Hillside >= 15% slope.'
            };
        case 'san_mateo':
            return {
                name: 'San Mateo',
                code: 'San Mateo Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Tiered FAR (50% for 1st 5,000 sq ft, 25% thereafter). 40% Coverage.'
            };
        case 'daly_city':
            return {
                name: 'Daly City',
                code: 'Daly City Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: '40% Coverage, 45% FAR. Hillside review >= 15% slope.'
            };
        case 'south_san_francisco':
            return {
                name: 'South San Francisco',
                code: 'SSF Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: '40% Coverage, 45% FAR. Hillside review >= 15% slope.'
            };
        case 'foster_city':
            return {
                name: 'Foster City',
                code: 'Foster City Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: null,
                description: 'PD District Review. Baseline: 45% Coverage, 50% FAR.'
            };
        case 'burlingame':
            return {
                name: 'Burlingame',
                code: 'Burlingame Municipal Code 25.10.060',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: null,
                description: 'FAR: 45% (1st 5k), 25% (5k-10k), 15% (>10k). 40% Coverage.'
            };
        case 'belmont':
            return {
                name: 'Belmont',
                code: 'Belmont Zoning Ord 360',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MFA: Lesser of Slope/Lot Size tables. Hillside review triggers at 15% slope.'
            };
        case 'san_carlos':
            return {
                name: 'San Carlos',
                code: 'San Carlos Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MFA: MAX(1.1k + 35%, 50%) for <=7.5k; 50% for >7.5k. 40% Coverage. Hillside >= 15%.'
            };
        case 'menlo_park':
            return {
                name: 'Menlo Park',
                code: 'Menlo Park Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'FAL: 30% + 500 (5k-10.5k); 3.85k + 10% (>10.5k). 40-35% Coverage. Hillside >= 15%.'
            };
        case 'millbrae':
            return {
                name: 'Millbrae',
                code: 'Millbrae Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'FAR: 55%, Coverage: 50%. Net Site Area reductions for slopes > 30%.'
            };
        case 'pacifica':
            return {
                name: 'Pacifica',
                code: 'Pacifica Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Coverage: 40%, FAR: 45% (Baseline). Hillside review >= 15%.'
            };
        case 'half_moon_bay':
            return {
                name: 'Half Moon Bay',
                code: 'HMB Municipal Code',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'FAR: 50%, Coverage: 50% (1-story) / 35% (2-story). Hillside review >= 15%.'
            };
        case 'orinda':
            return {
                name: 'Orinda',
                code: 'Orinda Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'MFA: Sliding scale (20% for >= 20k sq ft, max 7k). CDP for < 20k sq ft.'
            };
        case 'lafayette':
            return {
                name: 'Lafayette',
                code: 'Lafayette Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 20,
                description: 'HDP required if slope >= 20%. MFA/MDA informational baseline provided.'
            };
        case 'walnut_creek':
            return {
                name: 'Walnut Creek',
                code: 'Walnut Creek Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'concord':
            return {
                name: 'Concord',
                code: 'Concord Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'richmond':
            return {
                name: 'Richmond',
                code: 'Richmond Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'antioch':
            return {
                name: 'Antioch',
                code: 'Antioch Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'brentwood':
            return {
                name: 'Brentwood',
                code: 'Brentwood Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'oakley':
            return {
                name: 'Oakley',
                code: 'Oakley Zoning Ordinance',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'FAR: 40%, Coverage: 35%. Vineyard sensitivity and agricultural buffers apply.'
            };
        case 'san_pablo':
            return {
                name: 'San Pablo',
                code: 'San Pablo Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'FAR: 40%, Coverage: 40%. Pervious surface and mixed-use buffer requirements apply.'
            };
        case 'portola_valley':
            return {
                name: 'Portola Valley',
                code: 'PV Municipal Code 18.08',
                county: 'SAN_MATEO',
                usesLuf: false,
                slopeThreshold: 10,
                description: 'Uses Adjusted Parcel Area (APA) system. Area reduction factor = 1.0 - (0.005 * slope).'
            };
        case 'pittsburg':
            return {
                name: (jurisdiction || '').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
                code: 'CONTRA_COSTA',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'san_ramon':
            return {
                name: 'San Ramon',
                code: 'San Ramon Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
    case 'pleasant_hill':
            return {
                name: 'Pleasant Hill',
                code: 'Pleasant Hill Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
    case 'clayton':
            return {
                name: 'Clayton',
                code: 'Clayton Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
    case 'moraga':
            return {
                name: 'Moraga',
                code: 'Moraga Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
    case 'danville':
            return {
                name: 'Danville',
                code: 'Danville Municipal Code',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
    case 'alamo':
            return {
                name: 'Alamo',
                code: 'Contra Costa County Code (Alamo)',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Contra Costa County jurisdiction'
            };
        case 'martinez':
            return {
                name: 'Martinez',
                code: 'Martinez Municipal Code 22.12',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Baseline R-1: 35% Coverage, 0.40 FAR. Hillside review (Ch 22.34) required for slopes >= 15%.'
            };
        case 'el_cerrito':
            return {
                name: 'El Cerrito',
                code: 'El Cerrito Zoning Ord 19.07',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Baseline RS: 40% Coverage, 0.40 FAR. RAD process regulates massing and daylight planes.'
            };
        case 'hercules':
            return {
                name: 'Hercules',
                code: 'Hercules Zoning Ord 13-06',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Baseline RS: 40% Coverage, 0.40 FAR. Subject to specific plan or PD requirements if applicable.'
            };
        case 'pinole':
            return {
                name: 'Pinole',
                code: 'Pinole Municipal Code 17.20',
                county: 'CONTRA_COSTA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Baseline R-1: 40% Coverage, 0.40 FAR. Hillside review triggers at 15% slope.'
            };
        case 'mountain_view':
            return {
                name: 'Mountain View',
                code: 'MV Municipal Code Ch 36',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                description: 'Hillside Overlay triggers at 10% slope. Tiered FAR (45/40%) based on lot size.'
            };
        case 'sunnyvale':
            return {
                name: 'Sunnyvale',
                code: 'Sunnyvale Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                description: 'Floor area 45%. Hillside review/CEQA considerations for slopes > 10%.'
            };
        case 'santa_clara':
            return {
                name: 'Santa Clara',
                code: 'Santa Clara Code Ch 18.300',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Hillside Protection rules for slopes >= 15%. FAR: 45%, MDA: 40%.'
            };
        case 'milpitas':
            return {
                name: 'Milpitas',
                code: 'Milpitas Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                description: 'Base R1: 45% FAR, 40% Coverage. Hillside "H" overlay triggers at slope >= 10% (affects density/subdivision).'
            };
        case 'campbell':
            return {
                name: 'Campbell',
                code: 'Campbell Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: null,
                description: 'Flat city (no hillside overlay). R-1 sub-zones: R-1-6, R-1-8, R-1-10, etc. FAR bonus to 0.50 available.'
            };
        case 'gilroy':
            return {
                name: 'Gilroy',
                code: 'Gilroy Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                description: 'Slope-Density rules for slopes >= 10%. Max FAR: 45%, MDA: 40%.'
            };
        case 'morgan_hill':
            return {
                name: 'Morgan Hill',
                code: 'Morgan Hill Municipal Code',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: 10,
                description: 'Hillside status triggers at 10%. Portions >= 20% slope are non-buildable. MDA/MFA calculated on buildable area only.'
            };
        case 'oakland':
            return {
                name: 'Oakland',
                code: 'Oakland Planning Code Title 17',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 20,
                description: 'MDA: 40% of lot area. FAR: 50-55% based on lot size. Hillside triggers at 20% slope.'
            };
        case 'alameda':
            return {
                name: 'Alameda',
                code: 'Alameda Municipal Code Ch 30',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MDA: 40%, MFA: 45%. Hillside standards apply at 15% slope.'
            };
        case 'berkeley':
            return {
                name: 'Berkeley',
                code: 'Berkeley Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MDA: 40% (60% for Middle Housing). MFA: 50% (Baseline). Hillside triggers at 15% slope.'
            };
        case 'hayward':
            return {
                name: 'Hayward',
                code: 'Hayward Municipal Code (RL)',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MDA: 40%, MFA: 40%. Hillside stepped design required at 15% slope.'
            };
        case 'livermore':
            return {
                name: 'Livermore',
                code: 'Livermore Development Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MDA: 30%, MFA: 28-35% based on lot size. Hillside factors reviewed at 15% slope.'
            };
        case 'pleasanton':
            return {
                name: 'Pleasanton',
                code: 'Pleasanton Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'MDA: 40%, MFA: 45%. Hillside standards apply at 15% slope.'
            };
        case 'dublin':
            return {
                name: 'Dublin',
                code: 'Dublin Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: 20,
                description: 'MDA: 35%, MFA: 40%. Hillside standards apply at 20% slope.'
            };
        case 'newark':
            return {
                name: 'Newark',
                code: 'Newark Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'MDA: 40%, MFA: 45%.'
            };
        case 'union_city':
            return {
                name: 'Union City',
                code: 'Union City Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'MDA: 40%, MFA: 45%.'
            };
        case 'san_leandro':
            return {
                name: 'San Leandro',
                code: 'San Leandro Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'Tiered FAR based on lot size.'
            };
        case 'emeryville':
            return {
                name: 'Emeryville',
                code: 'Emeryville Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'MDA: 40%, MFA: 50%.'
            };
        case 'albany':
            return {
                name: 'Albany',
                code: 'Albany Municipal Code',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'MDA: 50%, MFA: 55%. Design Review > 0.45 FAR.'
            };
        case 'piedmont':
            return {
                name: 'Piedmont',
                code: 'Piedmont Municipal Code',
                county: 'ALAMEDA',
                usesLuf: true,
                slopeThreshold: 16,
                description: 'MDA: 40%, MFA: 45%. HCD penalty (LUF) applies for slopes > 6%.'
            };
        case 'scc_generic':
            return {
                name: 'Santa Clara County (General)',
                code: 'SCC',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: null,
                description: 'General Santa Clara County guidelines. Specific city ordinances may vary.'
            };
        case 'alameda_generic':
            return {
                name: 'Alameda County (General)',
                code: 'ALAMEDA',
                county: 'ALAMEDA',
                usesLuf: false,
                slopeThreshold: null,
                description: 'General Alameda County guidelines. Specific city ordinances may vary.'
            };
        case 'belvedere':
        case 'corte_madera':
        case 'fairfax':
        case 'larkspur':
        case 'mill_valley':
        case 'novato':
        case 'ross':
        case 'san_anselmo':
        case 'san_rafael':
        case 'sausalito':
        case 'tiburon':
        case 'marin_generic':
            return {
                name: (jurisdiction || 'Marin County').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
                code: jurisdiction === 'marin_generic' ? 'Marin County Code' : `${(jurisdiction || '').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())} Municipal Code`,
                county: 'MARIN',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Marin County jurisdiction. Hillside design review required for steep slopes (>15%). Zoning restricts FAR and Coverage.'
            };
        case 'napa_generic':
        case 'napa':
        case 'american_canyon':
        case 'calistoga':
        case 'st_helena':
        case 'yountville':
            return {
                name: (jurisdiction || 'Napa County').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
                code: jurisdiction === 'napa_generic' ? 'Napa County Code' : `${(jurisdiction || '').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())} Municipal Code`,
                county: 'NAPA',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Napa County jurisdiction. Hillside development is regulated by slope-density formulas and viewshed protections.'
            };
        case 'solano_generic':
        case 'benicia':
        case 'dixon':
        case 'fairfield':
        case 'rio_vista':
        case 'suisun_city':
        case 'vacaville':
        case 'vallejo':
            return {
                name: (jurisdiction || 'Solano County').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
                code: jurisdiction === 'solano_generic' ? 'Solano County Code' : `${(jurisdiction || '').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())} Municipal Code`,
                county: 'SOLANO',
                usesLuf: false,
                slopeThreshold: 15,
                description: 'Solano County jurisdiction. Hillside review triggers at 10-15%. Significant agricultural and marsh protections apply.'
            };
        case 'arnold':
        case 'calaveras_generic':
            return {
                name: jurisdiction === 'arnold' ? 'Arnold' : 'Calaveras County',
                code: 'Calaveras County Code Title 17',
                county: 'CALAVERAS',
                usesLuf: false,
                slopeThreshold: 30,
                description: 'Unincorporated Calaveras County jurisdiction. MDA uses residential lot coverage; MFA uses a two-story envelope estimate where no FAR is published.'
            };
        case 'frisco':
            return {
                name: 'Frisco',
                code: 'Frisco Zoning Ordinance',
                county: 'DENTON',
                usesLuf: false,
                slopeThreshold: null,
                mdaLabel: 'Maximum Lot Coverage',
                mfaLabel: 'Maximum Floor Area',
                description: 'Frisco, Texas. Standard single-family residential rules apply.'
            };
        case 'mckinney':
            return {
                name: 'McKinney',
                code: 'McKinney Code of Ordinances',
                county: 'COLLIN',
                usesLuf: false,
                slopeThreshold: null,
                mdaLabel: 'Maximum Lot Coverage',
                mfaLabel: 'Maximum Floor Area',
                description: 'McKinney, Texas. Standard single-family residential rules apply.'
            };
        default:
            return {
                name: jurisdiction || 'Unknown Jurisdiction',
                code: '',
                county: 'SCC',
                usesLuf: false,
                slopeThreshold: null,
                description: 'Property is in a jurisdiction not yet fully indexed. Using regional baseline data.'
            };
    }
};

/**
 * Get styling (colors, backgrounds, borders) for a jurisdiction
 * Based on County-level design patterns:
 * - SCC (Santa Clara): Blue theme
 * - San Mateo: Green theme
 * - Alameda: Indigo theme
 * - Contra Costa: Purple theme
 */
export const getJurisdictionStyle = (jurisdiction) => {
    // San Mateo County Cities
    const sanMateoCities = [
        'hillsborough', 'atherton', 'woodside', 'redwood_city', 'san_mateo', 
        'daly_city', 'south_san_francisco', 'foster_city', 'burlingame', 
        'belmont', 'san_carlos', 'menlo_park', 'millbrae', 'pacifica', 'half_moon_bay',
        'portola_valley'
    ];

    // Alameda County Cities
    const alamedaCities = [
        'oakland', 'alameda', 'berkeley', 'hayward', 'livermore', 
        'pleasanton', 'dublin', 'newark', 'union_city', 'san_leandro', 
        'emeryville', 'albany', 'piedmont', 'alameda_generic', 'fremont'
    ];

    // Contra Costa County Cities
    const contra_costa_cities = [
        'orinda', 'lafayette', 'walnut_creek', 'concord', 'richmond', 
        'antioch', 'brentwood', 'pittsburg', 'san_ramon', 'pleasant_hill',
        'martinez', 'el_cerrito', 'hercules', 'pinole', 'clayton', 'moraga', 'danville', 'alamo',
        'oakley', 'san_pablo'
    ];

    // Marin County Cities
    const marinCities = [
        'belvedere', 'corte_madera', 'fairfax', 'larkspur', 'mill_valley', 
        'novato', 'ross', 'san_anselmo', 'san_rafael', 'sausalito', 'tiburon', 'marin_generic'
    ];

    // Napa County Cities
    const napaCities = [
        'american_canyon', 'calistoga', 'napa', 'st_helena', 'yountville', 'napa_generic'
    ];

    // Solano County Cities
    const solanoCities = [
        'benicia', 'dixon', 'fairfield', 'rio_vista', 'suisun_city', 'vacaville', 'vallejo', 'solano_generic'
    ];
    const calaverasCities = ['arnold', 'calaveras_generic'];

    if (sanMateoCities.includes(jurisdiction)) {
        return {
            bg: '#f0fdf4',     // green-50
            color: '#16a34a',  // green-600
            border: '1px solid #bbf7d0' // green-200
        };
    }

    if (alamedaCities.includes(jurisdiction)) {
        return {
            bg: '#eef2ff',     // indigo-50
            color: '#4f46e5',  // indigo-600
            border: '1px solid #c7d2fe' // indigo-200
        };
    }

    if (contra_costa_cities.includes(jurisdiction)) {
        return {
            bg: '#f5f3ff',     // purple-50
            color: '#7c3aed',  // purple-600
            border: '1px solid #ddd6fe' // purple-200
        };
    }

    if (marinCities.includes(jurisdiction)) {
        return {
            bg: '#ecfdf5',     // emerald-50
            color: '#059669',  // emerald-600
            border: '1px solid #a7f3d0' // emerald-200
        };
    }

    if (napaCities.includes(jurisdiction)) {
        return {
            bg: '#fffbeb',     // amber-50
            color: '#d97706',  // amber-600
            border: '1px solid #fef3c7' // amber-200
        };
    }

    if (solanoCities.includes(jurisdiction)) {
        return {
            bg: '#fff1f2',     // rose-50
            color: '#e11d48',  // rose-600
            border: '1px solid #fecdd3' // rose-200
        };
    }

    if (calaverasCities.includes(jurisdiction)) {
        return {
            bg: '#f0fdfa',
            color: '#0f766e',
            border: '1px solid #99f6e4'
        };
    }

    // Default: SCC / Blue theme for everything else (SCC cities + unknown)
    return {
        bg: '#eff6ff',     // blue-50
        color: '#2563eb',  // blue-600
        border: '1px solid #bfdbfe' // blue-200
    };
};

// ... existing code ...

// ============================================
// CUPERTINO CALCULATIONS
// ============================================

/**
 * Calculate average slope percentage for Cupertino
 * S (%) = 0.0023 * I * L / A
 */
export const averageSlopePercentCupertino = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    return 0.0023 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Calculate Slope Adjustment Factor for RHS zone
 * SAF = 1.0 - (0.015 * (Slope% - 10.0))
 */
export const calculateSlopeAdjustmentFactorCupertino = (slopePercent) => {
    if (slopePercent <= 10.0) return 1.0;
    const saf = 1.0 - (0.015 * (slopePercent - 10.0));
    return Math.max(0.0, saf);
};

/**
 * Main entry point for Cupertino buildability metrics
 */
export const calculateCupertino = (slopePercent, lotAreaAcres, zoneCode = "R1") => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const zoneUpper = (zoneCode || "R1").toUpperCase();
    
    let mda, mfa;
    const slopeApplies = slopePercent > 10.0;

    if (zoneUpper.includes("RHS")) {
        // RHS Zone
        const saf = calculateSlopeAdjustmentFactorCupertino(slopePercent);
        
        let baseMfa;
        if (grossSqFt <= 10000) {
            baseMfa = 4500;
        } else {
            baseMfa = 4500 + 59.59 * (grossSqFt - 10000) / 1000;
        }
        
        mfa = Math.min(6500.0, baseMfa * saf);
        // MDA: 45% of net lot area for RHS
        mda = grossSqFt * 0.45;
    } else {
        // R-1 Zone
        // MFA: 45% FAR
        mfa = grossSqFt * 0.45;
        
        // MDA: 30% of usable rear yard (approximated as 15% of total lot)
        mda = grossSqFt * 0.15;
    }

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        mda_label: "Lot Coverage",
        mfa_label: "Maximum Allowable Floor Area",
        slopeApplies: slopeApplies,
        slopePercent: slopePercent,
        formulaLabel: 'SAF',
        formulaValue: slopeApplies ? calculateSlopeAdjustmentFactorCupertino(slopePercent) : 1.0,
        formulaTooltip: 'Slope Adjustment Factor: Reduction in MFA/MDA based on property slope'
    };
};



// ============================================
// SAN JOSE CALCULATIONS
// Municipal Code Title 20, Chapter 20.30
// Supports R-1-8, R-1-20, R-1-44
// ============================================

const SAN_JOSE_ZONE_CONFIG = {
    "R-1-8": {
        "minLotSqFt": 8000,
        "lotCoverage": 0.40,
        "coverageCapSqFt": 20000,
        "base1Story": 3300,
        "base2Story": 3000,
        "threshold": 10000,
        "increment": 0.15,
    },
    "R-1-20": {
        "minLotSqFt": 20000,
        "lotCoverage": 0.30,
        "coverageCapSqFt": 20000,
        "base1Story": 4950,
        "base2Story": 4500,
        "threshold": 24000,
        "increment": 0.050,
    },
    "R-1-44": {
        "minLotSqFt": 44000,
        "lotCoverage": 0.20,
        "coverageCapSqFt": 20000,
        "base1Story": 6600,
        "base2Story": 6000,
        "threshold": 44000,
        "increment": 0.075,
    },
};

const SAN_JOSE_DEFAULT_ZONE = "R-1-8";

// SJMC: projects with effective FAR > 0.65 require a public design-review hearing
const SAN_JOSE_FAR_DESIGN_REVIEW_THRESHOLD = 0.65;

// Slope >= 30% triggers restricted-development flag (no standard grading allowed)
const SAN_JOSE_SLOPE_RESTRICTION_THRESHOLD = 30.0;

/**
 * Calculate average slope percentage for San Jose
 * S = (0.00229 * I * L) / A
 */
export const averageSlopePercentSanJose = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    return 0.00229 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Internal MFA calculation for San Jose
 */
const calculateMfaSanJoseInternal = (lotAreaSqFt, zoneCfg, stories = 2) => {
    const base = stories === 1 ? zoneCfg.base1Story : zoneCfg.base2Story;
    const thresh = zoneCfg.threshold;
    const incr = zoneCfg.increment;

    if (lotAreaSqFt <= thresh) {
        return base;
    }
    return base + incr * (lotAreaSqFt - thresh);
};

/**
 * Return a list of warning strings for suspicious input values for San Jose.
 */
const validateSanJoseInputs = (lotAreaSqFt, zoneCfg, contourIntervalSelectedFt, contourIntervalUsedFt) => {
    const warnings = [];

    // Contour interval mismatch
    if (
        contourIntervalSelectedFt !== undefined && contourIntervalSelectedFt !== null &&
        contourIntervalUsedFt !== undefined && contourIntervalUsedFt !== null &&
        Math.abs(contourIntervalSelectedFt - contourIntervalUsedFt) > 0.01
    ) {
        warnings.push(
            `CONTOUR INTERVAL MISMATCH: selected=${contourIntervalSelectedFt} ft but used=${contourIntervalUsedFt} ft. Average slope will be computed with the 'used' value. Verify ArcGIS layer resolution.`
        );
    }

    // Parcel area below zone minimum
    const minLot = zoneCfg.minLotSqFt || 0;
    if (lotAreaSqFt < minLot * 0.90) { // allow 10% tolerance
        warnings.push(
            `PARCEL AREA WARNING: ${lotAreaSqFt.toFixed(1)} sq ft is more than 10% below the zone minimum of ${minLot.toLocaleString()} sq ft. This likely indicates a clipped or incomplete polygon.`
        );
    }

    return warnings;
};

const SAN_JOSE_SQFT_PER_ACRE = 43560.0;

/**
 * Main entry point for San Jose buildability metrics
 */
export const calculateSanJose = (slopePercent, lotAreaAcres, zoneCode = "R-1-8", stories = 2, contourIntervalSelectedFt = null, contourIntervalUsedFt = null) => {
    // 1. Resolve zone
    const zoneUpper = (zoneCode || SAN_JOSE_DEFAULT_ZONE).toUpperCase().replace(" ", "-");
    const cfg = SAN_JOSE_ZONE_CONFIG[zoneUpper] || SAN_JOSE_ZONE_CONFIG[SAN_JOSE_DEFAULT_ZONE];

    // 2. Area conversion
    const lotAreaSqFt = lotAreaAcres * SAN_JOSE_SQFT_PER_ACRE;
    
    // 3. Input validation
    const warnings = validateSanJoseInputs(lotAreaSqFt, cfg, contourIntervalSelectedFt, contourIntervalUsedFt);

    // 4. MDA — zone-specific lot coverage, capped at 20,000 sq ft
    const mda = Math.min(lotAreaSqFt * cfg.lotCoverage, cfg.coverageCapSqFt);
    
    // 5. MFA — tiered formula per zone
    const mfa = calculateMfaSanJoseInternal(lotAreaSqFt, cfg, stories);
    
    // 6. Derived flags
    const effectiveFar = lotAreaSqFt > 0 ? mfa / lotAreaSqFt : 0.0;
    const requiresDesignReview = effectiveFar > SAN_JOSE_FAR_DESIGN_REVIEW_THRESHOLD;
    const slopeRestricted = slopePercent >= SAN_JOSE_SLOPE_RESTRICTION_THRESHOLD;

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        lotAreaSqFt: Math.round(lotAreaSqFt * 10) / 10,
        avg_slope_percent_SJ: Math.round(slopePercent * 100) / 100,
        effectiveFar: Math.round(effectiveFar * 1000) / 1000,
        slopeRestricted: slopeRestricted,
        requiresDesignReview: requiresDesignReview,
        slopeApplies: slopeRestricted, // Primary flag for map/grading status
        warnings: warnings,
        formulaLabel: 'SJ Tier',
        formulaValue: Math.round(effectiveFar * 100) / 100,
        formulaTooltip: `San Jose ${zoneUpper}: ${cfg.lotCoverage * 100}% Cov, Tiered MFA. FAR ${Math.round(effectiveFar * 100)}%`
    };
};


// ============================================
// LOS ALTOS CITY CALCULATIONS (LAMC Chapter 14)
// ============================================

/**
 * Calculate average slope percentage for Los Altos
 * S (%) = 0.0023 * I * L / A
 */
export const averageSlopePercentLosAltos = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    return 0.0023 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Los Altos City does NOT use Lot Unit Factor (LUF).
 * For consistency we return the lot area in acres.
 */
export const lotUnitFactorLosAltos = (areaAcres, slopePercent) => {
    return areaAcres;
};

/**
 * Calculate maximum floor area for Los Altos
 * Per Los Altos Municipal Code Chapter 14
 */
export const maximumFloorAreaLosAltos = (lotAreaSqFt, slopePercent, zone = "R1") => {
    const zoneUpper = (zone || "R1").toUpperCase().trim();
    const isCommercial = ["CN", "CD", "CRS", "CT", "OA", "CD/R3"].includes(zoneUpper);

    let baseFar = 0.35;
    let lotCoverageMax = 0.40;
    let permittedUses = ["SFR", "ADU", "JADU"];

    if (isCommercial) {
        if (zoneUpper === "CN") {
            baseFar = 0.35;
            lotCoverageMax = 0.35;
            permittedUses = ["Retail", "Office", "Restaurant", "Personal Services", "Mixed-Use"];
        } else if (zoneUpper === "CD") {
            baseFar = 2.0;
            lotCoverageMax = 1.0;
            permittedUses = ["Retail", "Office", "Restaurant", "Mixed-Use"];
        } else if (zoneUpper === "CRS") {
            baseFar = 1.0;
            lotCoverageMax = 1.0;
            permittedUses = ["Retail", "Restaurant", "Personal Services", "Mixed-Use"];
        } else if (zoneUpper === "CT") {
            baseFar = 0.35;
            lotCoverageMax = 0.40;
            permittedUses = ["Retail", "Office", "Service", "Auto", "Mixed-Use"];
        } else if (zoneUpper === "OA") {
            baseFar = 0.35;
            lotCoverageMax = 0.40;
            permittedUses = ["Office", "Administrative", "Medical", "Mixed-Use"];
        } else { // CD/R3
            baseFar = 1.5;
            lotCoverageMax = 0.80;
            permittedUses = ["Retail", "Office", "Restaurant", "Multi-Family", "Mixed-Use"];
        }
    } else {
        // Residential R1 tiered: matches previous frontend logic
        if (lotAreaSqFt <= 10000) {
            baseFar = 0.45;
        } else if (lotAreaSqFt <= 20000) {
            baseFar = 0.40;
        } else {
            baseFar = 0.35;
        }
        lotCoverageMax = 0.40;
    }

    // Check slope restrictions
    let slopeWarning = "";
    let adjustedFar = baseFar;

    if (slopePercent > 30.0) {
        slopeWarning = "Slopes >30% severely restrict development. Geotechnical review required.";
        adjustedFar = baseFar * 0.5; // 50% reduction
    } else if (slopePercent > 20.0) {
        slopeWarning = "Slopes >20% require geotechnical review and may have additional setbacks.";
        adjustedFar = baseFar * 0.85; // 15% reduction
    } else if (slopePercent > 15.0) {
        slopeWarning = "Slopes >15% may require additional drainage and grading review.";
    }

    const maxFloorArea = lotAreaSqFt * adjustedFar;

    return {
        maxFloorArea: Math.round(maxFloorArea * 10) / 10,
        baseFar: baseFar,
        adjustedFar: Math.round(adjustedFar * 10000) / 10000,
        lotCoverageMax: lotCoverageMax,
        slopePercent: slopePercent,
        slopeWarning: slopeWarning,
        developable: true,
        zone: zoneUpper,
        permittedUses: permittedUses
    };
};

/**
 * Main entry point for Los Altos City buildability metrics
 */
export const calculateLosAltos = (slopePercent, lotAreaAcres, zoneCode = "R1") => {
    const lotAreaSqFt = lotAreaAcres * 43560.0;
    const result = maximumFloorAreaLosAltos(lotAreaSqFt, slopePercent, zoneCode);

    // MDA: lotCoverageMax max lot coverage
    const mda = lotAreaSqFt * result.lotCoverageMax;

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: result.maxFloorArea,
        slopeApplies: slopePercent > 15.0,
        slopePercent: slopePercent,
        slopeWarning: result.slopeWarning,
        baseFar: result.baseFar,
        adjustedFar: result.adjustedFar,
        formulaLabel: result.adjustedFar !== result.baseFar ? 'Adj FAR' : 'FAR',
        formulaValue: result.adjustedFar,
        formulaTooltip: 'Floor Area Ratio: FAR limits apply based on zoning district rules.'
    };
};


// ============================================
// LOS ALTOS HILLS (LAH) CALCULATIONS
// LAH Worksheet math (Worksheet #1): S (avg slope), LUF, MDA, MFA
// ============================================

/**
 * Calculate Lot Unit Factor for LAH
 * LUF = An for S <= 10
 * LUF = An*(1 - 0.02143*(S-10)) for 10 < S < 30
 * Past 30% the Town caps with separate rules
 */
export const lotUnitFactorLAH = (areaAcres, slopePercent) => {
    if (slopePercent <= 10.0) {
        return areaAcres;
    }
    if (slopePercent < 30.0) {
        return areaAcres * (1.0 - 0.02143 * (slopePercent - 10.0));
    }
    // Cap behavior (treat >=30 same as 30 for LUF)
    return areaAcres * (1.0 - 0.02143 * (30.0 - 10.0));
};

/**
 * Calculate MDA and MFA from LUF for Los Altos Hills
 * @returns {object} { mda, mfa, requiresCdp }
 */
export const mdaMfaFromLufLAH = (slopePercent, LUF) => {
    // Determine CDP status first
    const requiresCdp = (LUF <= 0.50);

    if (requiresCdp) {
        // Special CDP Rule:
        // MFA scales linearly from 0 to 5000 relative to LUF 0.0->0.50
        const MFA = (LUF / 0.50) * 5000.0;
        // MDA is MFA + 2100 (assuming SDA doesn't cap it further)
        const MDA = MFA + 2100.0;
        return { mda: Math.round(MDA * 10) / 10, mfa: Math.round(MFA * 10) / 10, requiresCdp };
    }

    // Standard Case (LUF > 0.50) --> apply formulas + guaranteed minimums
    let MDA, MFA;

    // MDA calculation
    if (slopePercent <= 10.0) {
        MDA = LUF * 15000.0;
    } else if (slopePercent < 30.0) {
        MDA = LUF * (15000.0 - 375.0 * (slopePercent - 10.0));
    } else {
        MDA = LUF * 7500.0;
    }

    // MFA calculation
    if (slopePercent <= 10.0) {
        MFA = LUF * 6000.0;
    } else if (slopePercent < 30.0) {
        MFA = LUF * (6000.0 - 50.0 * (slopePercent - 10.0));
    } else {
        MFA = LUF * 5000.0;
    }

    // Minimum floors apply because LUF > 0.50
    MDA = Math.max(MDA, 7500.0);
    MFA = Math.max(MFA, 5000.0);

    return { mda: Math.round(MDA * 10) / 10, mfa: Math.round(MFA * 10) / 10, requiresCdp };
};

/**
 * Complete LAH calculation from slope and lot area
 */
export const calculateLAH = (slopePercent, lotAreaAcres) => {
    const LUF = lotUnitFactorLAH(lotAreaAcres, slopePercent);
    const result = mdaMfaFromLufLAH(slopePercent, LUF);
    return {
        ...result,
        luf: Math.round(LUF * 1000) / 1000,
        slopePercent,
        formulaLabel: 'LUF',
        formulaValue: Math.round(LUF * 1000) / 1000,
        formulaTooltip: 'Lot Unit Factor: The net buildable area ratio based on average slope'
    };
};

// ============================================
// PALO ALTO CALCULATIONS (PAMC 18.16.090)
// ============================================

/**
 * Calculate maximum floor area for Palo Alto sloped lots
 * Per PAMC 18.16.090:
 * - Applies when average slope > 20%
 * - Formula: Max FA = Lot Area * [0.30 - (0.004 * (S - 20))]
 * - Minimum: 3,500 sq ft (for R-1 zones)
 */
export const maximumFloorAreaPaloAlto = (lotAreaSqFt, slopePercent) => {
    const BASE_FAR = 0.30; // Base FAR for R-1 zones (30%)
    const SLOPE_THRESHOLD = 20.0;
    const MINIMUM_FA = 3500.0;

    const slopeApplies = slopePercent > SLOPE_THRESHOLD;

    if (!slopeApplies) {
        // Use base FAR without slope reduction
        const maxFa = lotAreaSqFt * BASE_FAR;
        return {
            maxFloorArea: Math.round(maxFa * 10) / 10,
            baseFar: BASE_FAR,
            adjustedFar: BASE_FAR,
            slopeApplies: false,
            minimumApplied: false,
            slopePercent: slopePercent
        };
    }

    // Apply slope density formula
    let adjustedFar = BASE_FAR - (0.004 * (slopePercent - SLOPE_THRESHOLD));

    // FAR cannot be negative
    adjustedFar = Math.max(adjustedFar, 0.0);

    // Calculate floor area
    let maxFa = lotAreaSqFt * adjustedFar;

    // Apply minimum
    const minimumApplied = maxFa < MINIMUM_FA;
    if (minimumApplied) {
        maxFa = MINIMUM_FA;
        adjustedFar = MINIMUM_FA / lotAreaSqFt;
    }

    return {
        maxFloorArea: Math.round(maxFa * 10) / 10,
        baseFar: BASE_FAR,
        adjustedFar: Math.round(adjustedFar * 10000) / 10000,
        slopeApplies: true,
        minimumApplied: minimumApplied,
        slopePercent: slopePercent
    };
};

/**
 * Calculate MDA and MFA for Palo Alto
 * For Palo Alto: MDA = MFA (lot coverage same as floor area for API consistency)
 */
export const calculatePaloAlto = (slopePercent, lotAreaAcres) => {
    const lotAreaSqFt = lotAreaAcres * 43560.0;
    const result = maximumFloorAreaPaloAlto(lotAreaSqFt, slopePercent);

    // For Palo Alto, MDA and MFA are the same (no separate lot coverage calculation)
    return {
        mda: result.maxFloorArea,
        mfa: result.maxFloorArea,
        slopeApplies: result.slopeApplies,
        adjustedFar: result.adjustedFar,
        baseFar: result.baseFar,
        minimumApplied: result.minimumApplied,
        slopePercent: slopePercent,
        formulaLabel: result.slopeApplies ? 'Adj FAR' : 'FAR',
        formulaValue: result.adjustedFar,
        formulaTooltip: 'Floor Area Ratio: PAMC 18.16.090 slope density reduction applies if slope > 20%'
    };
};

// ============================================
// SARATOGA CALCULATIONS
// ============================================

/**
 * Calculate average slope percentage for Saratoga
 * S (%) = 0.002296 * I * L / A
 */
export const averageSlopePercentSaratoga = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    return 0.002296 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Calculate Net Site Area after slope deductions per Saratoga Code
 */
export const calculateNetSiteAreaSaratoga = (grossAreaSqFt, slopePercent) => {
    if (slopePercent <= 10.0) return grossAreaSqFt;

    let deductionPct;
    if (slopePercent <= 20.0) {
        deductionPct = 10.0 + 2.0 * (slopePercent - 10.0);
    } else if (slopePercent <= 30.0) {
        deductionPct = 30.0 + 3.0 * (slopePercent - 20.0);
    } else {
        deductionPct = 60.0;
    }

    return grossAreaSqFt * (1.0 - deductionPct / 100.0);
};

/**
 * Calculate Floor Area Allowance based on Net Site Area
 */
export const calculateFloorAreaAllowanceSaratoga = (netSiteAreaSqFt, zone = "R1-40000") => {
    const a = netSiteAreaSqFt;
    const zoneUpper = (zone || "R1-40000").toUpperCase();

    if (a <= 5000) return a * 0.45;

    let mfa;
    if (a <= 10000) {
        mfa = 2400 + (a - 5000) * (160 / 1000);
    } else if (a <= 15000) {
        mfa = 3200 + (a - 10000) * (170 / 1000);
    } else if (a <= 40000) {
        mfa = 4050 + (a - 15000) * (78 / 1000);
        if (zoneUpper.includes("R1-10")) {
            mfa = Math.min(mfa, 4400);
        }
    } else if (a <= 80000) {
        mfa = 6000 + (a - 40000) * (20 / 1000);
    } else if (a <= 200000) {
        mfa = 6800 + (a - 80000) * (10 / 1000);
        mfa = Math.min(mfa, zoneUpper.includes("HR") ? 8000 : 7200);
    } else {
        mfa = zoneUpper.includes("HR") ? 8000 : 7200;
    }

    return mfa;
};

/**
 * Main entry point for Saratoga buildability metrics
 */
export const calculateSaratoga = (slopePercent, lotAreaAcres, zoneCode = "R1-40000") => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const netSiteArea = calculateNetSiteAreaSaratoga(grossSqFt, slopePercent);
    const mfa = calculateFloorAreaAllowanceSaratoga(netSiteArea, zoneCode);

    let mda;
    const zoneUpper = (zoneCode || "R1-40000").toUpperCase();
    if (zoneUpper.includes("HR")) {
        mda = Math.min(netSiteArea * 0.25, 15000.0);
    } else {
        mda = netSiteArea * 0.35;
    }

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        mda_label: "Site Coverage",
        mfa_label: "Floor Area Allowance",
        slopeApplies: slopePercent > 10.0,
        netSiteArea: Math.round(netSiteArea * 10) / 10,
        slopePercent,
        formulaLabel: 'NSA',
        formulaValue: Math.round(netSiteArea * 10) / 10,
        formulaTooltip: 'Net Site Area: The developable lot area after slope-based deductions'
    };
};

// ============================================
// LOS GATOS CALCULATIONS
// ============================================

/**
 * Calculate average slope percentage for Los Gatos
 * S (%) = 0.0023 * I * L / A
 */
export const averageSlopePercentLosGatos = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    return 0.0023 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Calculate Net Site Area after slope deductions per Los Gatos Code
 */
export const calculateNetSiteAreaLosGatos = (grossAreaSqFt, slopePercent) => {
    if (slopePercent <= 10.0) return grossAreaSqFt;

    let deductionPct;
    if (slopePercent <= 30.0) {
        deductionPct = 10.0 + 2.0 * (slopePercent - 10.0);
    } else if (slopePercent <= 50.0) {
        deductionPct = 50.0 + 2.0 * (slopePercent - 30.0);
    } else {
        deductionPct = 90.0;
    }

    return grossAreaSqFt * (1.0 - deductionPct / 100.0);
};

/**
 * Calculate Maximum Allowed Gross Floor Area based on Net Site Area
 */
export const calculateFloorAreaAllowanceLosGatos = (netSiteAreaSqFt) => {
    const a = netSiteAreaSqFt;

    if (a <= 11000) return 3800;
    if (a >= 33000) return 6000;
    
    // Explicit stepped values per Table 2 (11,001 - 32,000)
    // The table uses 'up to' buckets, so we use Math.ceil for the 1,000 sq ft increments.
    const steps = Math.ceil((a - 11000) / 1000.0);
    const mfa = 3800 + (steps * 100);
    
    return Math.min(mfa, 6000);
};

/**
 * Main entry point for Los Gatos buildability metrics
 */
export const calculateLosGatos = (slopePercent, lotAreaAcres, zoneCode = "HR") => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const netSiteArea = calculateNetSiteAreaLosGatos(grossSqFt, slopePercent);
    const table2Mfa = calculateFloorAreaAllowanceLosGatos(netSiteArea);

    const zoneClean = (zoneCode || "").toUpperCase().replace("-", "").trim();
    const isStandardR1 = zoneClean === "R1" || zoneClean.startsWith("R1");

    let farValue = 0;
    let formulaTooltip = "";
    let finalMfa = table2Mfa;
    
    if (isStandardR1) {
        // Standard R-1 calculations from pdf
        const A = netSiteArea / 1000.0;
        let residential_far = 0;
        let garage_far = 0;
        if (netSiteArea < 5000) {
            if (A > 0) {
                const small_lot_far = 0.49 - (A - 1) * 0.66 / A;
                residential_far = Math.max(small_lot_far, 0.35);
            } else {
                residential_far = 0.49;
            }
            garage_far = 0.10;
            farValue = Math.max(0.0, residential_far) + Math.max(0.0, garage_far);
            finalMfa = netSiteArea * farValue;
            formulaTooltip = `Los Gatos ${zoneCode}: FAR = Residential FAR (${(residential_far * 100).toFixed(1)}%) + Garage FAR (${(garage_far * 100).toFixed(1)}%) = ${(farValue * 100).toFixed(1)}%. Formulas: Small Lot FAR = 0.49 - (A - 1) * 0.66 / A; Garage FAR = 0.10 (where A = net lot area / 1000 = ${(A).toFixed(2)}).`;
        } else {
            residential_far = 0.35 - (A - 5) * 0.20 / 25;
            garage_far = 0.10 - (A - 5) * 0.07 / 25;
            farValue = Math.max(0.0, residential_far) + Math.max(0.0, garage_far);
            finalMfa = netSiteArea * farValue;
            formulaTooltip = `Los Gatos ${zoneCode}: FAR = Residential FAR (${(residential_far * 100).toFixed(1)}%) + Garage FAR (${(garage_far * 100).toFixed(1)}%) = ${(farValue * 100).toFixed(1)}%. Formulas: Residential FAR = 0.35 - (A - 5) * 0.20 / 25; Garage FAR = 0.10 - (A - 5) * 0.07 / 25 (where A = net lot area / 1000 = ${(A).toFixed(2)}).`;
        }
    } else {
        // Hillside/Table 2
        farValue = grossSqFt > 0 ? table2Mfa / grossSqFt : 0;
        formulaTooltip = `Due to the lot size and hillside regulations, the maximum allowed floor area is strictly capped at ${table2Mfa.toLocaleString()} sq ft (effective FAR: ${(farValue * 100).toFixed(1)}%).`;
    }

    return {
        mda: null,
        mfa: Math.round(finalMfa * 10) / 10,
        mda_label: "Maximum Development Area",
        mfa_label: "Maximum Allowed Gross Floor Area",
        slopeApplies: slopePercent > 10.0,
        netSiteArea: Math.round(netSiteArea * 10) / 10,
        slopePercent,
        formulaLabel: 'FAR',
        farValue: farValue,
        formulaValue: Math.round(farValue * 1000) / 1000,
        formulaTooltip: formulaTooltip
    };
};

// ============================================
// MONTE SERENO CALCULATIONS
// ============================================

/**
 * Calculate average slope percentage for Monte Sereno
 * S (%) = 0.00229 * I * L / A
 */
export const averageSlopePercentMonteSereno = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    return 0.00229 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Calculate minimum required lot size based on Slope Density Formula
 */
export const calculateMinLotSizeMonteSereno = (slopePercent, zoneCode = "R1-20") => {
    const s_calc = Math.max(slopePercent, 10.0);
    const zone = (zoneCode || "R1-20").toUpperCase().replace("-", "");
    
    let ls;
    if (zone.includes("R18")) {
        ls = 43560.0 * (5.45 - 0.089 * s_calc);
    } else if (zone.includes("R120")) {
        ls = 43560.0 * (2.20 - 0.036 * s_calc);
    } else if (zone.includes("R144")) {
        ls = 43560.0 * (1.00 - 0.016 * s_calc);
    } else {
        ls = 43560.0 * (2.20 - 0.036 * s_calc);
    }
    return ls;
};

/**
 * Calculate Maximum Allowed Building Size for Monte Sereno
 */
export const calculateFloorAreaAllowanceMonteSereno = (lotAreaSqFt, slopePercent, zoneCode = "R1-20") => {
    const zone = (zoneCode || "R1-20").toUpperCase().replace("-", "");
    const ls_slope = calculateMinLotSizeMonteSereno(slopePercent, zoneCode);
    
    let base_mfa, overage_threshold, increase_rate;
    
    if (zone.includes("R18")) {
        base_mfa = 3300.0;
        overage_threshold = Math.max(10000.0, ls_slope);
        increase_rate = 0.15;
    } else if (zone.includes("R120")) {
        base_mfa = 4950.0;
        overage_threshold = Math.max(24000.0, ls_slope);
        increase_rate = 0.05;
    } else if (zone.includes("R144")) {
        base_mfa = 6600.0;
        overage_threshold = Math.max(44000.0, ls_slope);
        increase_rate = 0.075;
    } else {
        base_mfa = 6600.0;
        overage_threshold = Math.max(44000.0, ls_slope);
        increase_rate = 0.075;
    }

    const mfa = base_mfa + (lotAreaSqFt > overage_threshold ? (lotAreaSqFt - overage_threshold) * increase_rate : 0);
    return Math.round(mfa * 10) / 10;
};

// ============================================
// FREMONT CALCULATIONS
// Formulae based on Fremont Municipal Code Title 18 and Hill Area Initiative
// ============================================

/**
 * Calculate average slope percentage for Fremont
 * S = 100(I)(L)/A
 * Standard hillside slope formula.
 */
export const averageSlopePercentFremont = (totalContourLenFt, intervalFt, areaAcres) => {
    if (areaAcres <= 0) return 0.0;
    // 100 / 43560 approx 0.0023
    return 0.0023 * intervalFt * totalContourLenFt / areaAcres;
};

/**
 * Main entry point for Fremont buildability metrics
 */
export const calculateFremont = (slopePercent, lotAreaAcres, zoningCode = "R-1") => {
    const lotAreaSqFt = lotAreaAcres * 43560.0;

    const tiered = (area, tiers) => {
        let remaining = area;
        let total = 0.0;
        let prevThreshold = 0.0;
        tiers.forEach(([threshold, rate]) => {
            if (remaining <= 0) return;
            const chunk = Math.min(remaining, threshold - prevThreshold);
            total += chunk * rate;
            remaining -= chunk;
            prevThreshold = threshold;
        });
        if (remaining > 0 && tiers.length > 0) {
            total += remaining * tiers[tiers.length - 1][1];
        }
        return total;
    };

    let mfa_ft2;
    let mda_ft2;
    let is_restricted = false;
    let slope_warning = "";

    // Backend parity: Fremont MDA is lot coverage, MFA is floor area.
    if ((zoningCode || "R-1").toUpperCase().includes("R-1")) {
        mda_ft2 = tiered(lotAreaSqFt, [[10000, 0.30], [20000, 0.30], [43560, 0.25], [Infinity, 0.20]]);
        mfa_ft2 = tiered(lotAreaSqFt, [[5000, 0.45], [12000, 0.40], [25000, 0.40], [43560, 0.35], [Infinity, 0.30]]);
    } else {
        mfa_ft2 = lotAreaSqFt * 0.35;
        mda_ft2 = lotAreaSqFt * 0.25;
    }

    // Hillside Combining District (H-I) logic:
    // Minimum lot area increased by 2% for each 1% slope exceeding 6%.
    // This implies a reduction in buildable area or effective density.
    if (slopePercent > 6.0) {
        const penalty_factor = Math.min(0.50, (slopePercent - 6.0) * 0.02);
        mfa_ft2 *= (1.0 - penalty_factor);
        mda_ft2 *= (1.0 - penalty_factor);
        slope_warning = `Hillside penalty applied: ${(penalty_factor * 100).toFixed(1)}% reduction`;
    }

    // Slope restrictions: Generally prohibit buildings on slopes > 30%
    if (slopePercent >= 30.0) {
        is_restricted = true;
    }
    
    const effectiveFar = lotAreaSqFt > 0 ? mfa_ft2 / lotAreaSqFt : 0.0;

    return {
        mda: Math.round(mda_ft2 * 10) / 10,
        mfa: Math.round(mfa_ft2 * 10) / 10,
        requires_design_review: is_restricted || slopePercent > 10.0,
        slopeRestricted: is_restricted,
        slopeApplies: slopePercent > 6.0,
        warning: slope_warning,
        formulaLabel: 'Coverage/FAR',
        formulaValue: Math.round(effectiveFar * 100) / 100,
        formulaTooltip: `Fremont ${zoningCode}: Lot coverage can be lower than floor area because upper-story floor area counts toward MFA but not ground coverage. Hillside penalty applies > 6% slope.`
    };
};

// ============================================
// SOLANO COUNTY CALCULATIONS
// ============================================

/**
 * Provides a regional baseline for Solano County cities.
 */
export const calculateSolano = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    
    // Baseline: 40% Coverage, 45% FAR
    let mda = lotAreaFt2 * 0.40;
    let mfa = lotAreaFt2 * 0.45;
    
    const is_hillside = slopePercent >= 15.0;
    
    if (is_hillside) {
        const penalty = Math.min(0.4, (slopePercent - 15.0) * 0.01);
        mda *= (1.0 - penalty);
        mfa *= (1.0 - penalty);
    }
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_hillside,
        slopePercent,
        formulaLabel: is_hillside ? 'Hillside' : 'Baseline',
        formulaValue: 0.45,
        formulaTooltip: 'Solano Baseline: 40% Coverage, 45% FAR. Hillside reduction applies if slope >= 15%.'
    };
};

export const calculateArnold = (slopePercent, lotAreaAcres, zoneCode = "R1") => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const zone = (zoneCode || "R1").toUpperCase().replace(/\s+/g, "");
    let coverage = 0.40;
    let far = 0.80;

    if (zone.startsWith("RR")) {
        coverage = 0.30;
        far = 0.60;
    } else if (zone.startsWith("RA") || zone.startsWith("A1") || zone.startsWith("A-1")) {
        coverage = 0.20;
        far = 0.40;
    } else if (zone.startsWith("R3")) {
        coverage = 0.60;
        far = 1.20;
    } else if (zone.startsWith("R2")) {
        coverage = 0.50;
        far = 1.00;
    }

    const isSteep = slopePercent >= 30.0;
    return {
        mda: Math.round(lotAreaFt2 * coverage * 10) / 10,
        mfa: Math.round(lotAreaFt2 * far * 10) / 10,
        slopeApplies: isSteep,
        slopePercent,
        formulaLabel: 'Calaveras County Envelope',
        formulaValue: far,
        formulaTooltip: `Calaveras County (${zoneCode}): ${Math.round(coverage * 100)}% lot coverage. MFA modeled as ${Math.round(far * 100)}% two-story envelope where FAR is not explicit.`
    };
};

export const calculateFrisco = (slopePercent, lotAreaAcres, zoneCode = "SF-7") => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const zone = (zoneCode || "SF-7").toUpperCase().replace(/\s+/g, "");
    let coverage = 0.45;
    if (zone.includes("SF-10")) {
        coverage = 0.40;
    } else if (zone.includes("RE")) {
        coverage = 0.30;
    }
    const far = coverage * 2; // Two-story envelope
    return {
        mda: Math.round(lotAreaFt2 * coverage * 10) / 10,
        mfa: Math.round(lotAreaFt2 * far * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'Frisco Envelope',
        formulaValue: far,
        formulaTooltip: `Frisco (${zoneCode}): ${Math.round(coverage * 100)}% lot coverage. MFA modeled as ${Math.round(far * 100)}% two-story envelope.`
    };
};

export const calculateMcKinney = (slopePercent, lotAreaAcres, zoneCode = "SF7") => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const zone = (zoneCode || "SF7").toUpperCase().replace(/\s+/g, "");
    let coverage = 0.45;
    if (zone.includes("SF10")) {
        coverage = 0.40;
    } else if (zone.includes("RE")) {
        coverage = 0.30;
    }
    const far = coverage * 2; // Two-story envelope
    return {
        mda: Math.round(lotAreaFt2 * coverage * 10) / 10,
        mfa: Math.round(lotAreaFt2 * far * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'McKinney Envelope',
        formulaValue: far,
        formulaTooltip: `McKinney (${zoneCode}): ${Math.round(coverage * 100)}% lot coverage. MFA modeled as ${Math.round(far * 100)}% two-story envelope.`
    };
};
export const calculateMonteSereno = (slopePercent, lotAreaAcres, zoneCode = "R1-20") => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mfa = calculateFloorAreaAllowanceMonteSereno(grossSqFt, slopePercent, zoneCode);
    
    // MDA: Impervious Coverage
    let ic_pct = 40.0;
    if (slopePercent > 10.0) {
        const slope_deduction = 2.0 * ((slopePercent - 10.0) / 5.0);
        ic_pct -= slope_deduction;
    }
    ic_pct = Math.max(ic_pct, 12.0);
    const mda = grossSqFt * (ic_pct / 100.0);

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        mda_label: "Maximum Structural Coverage",
        mfa_label: "Maximum Size of Main Dwelling Unit",
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: 'IC',
        formulaValue: Math.round(ic_pct * 10) / 10,
        formulaTooltip: 'Impervious Coverage: Percentage of lot area allowed for structures and hardscape'
    };
};
// ============================================
// NEW CITIES CALCULATIONS (Wrappers)
// ============================================

/**
 * Hillsborough Calculation Wrapper
 */
export const calculateHillsborough = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let mfa;
    if (lotAreaFt2 <= 43560.0) {
        mfa = lotAreaFt2 * 0.25;
    } else {
        mfa = (43560.0 * 0.25) + ((lotAreaFt2 - 43560.0) * 0.15);
    }
    mfa = Math.max(mfa, 2500.0);
    const mda = lotAreaFt2 * 0.25;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent > 20.0,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: (mfa / lotAreaFt2),
        formulaTooltip: 'Hillsborough: 25% for 1st acre, 15% thereafter.'
    };
};

/**
 * Atherton Calculation Wrapper
 */
export const calculateAtherton = (slopePercent, lotAreaAcres, zoneCode = 'R-1A') => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const effectiveZone = (zoneCode || 'R-1A').toUpperCase().replace('-', '').trim();
    let mfa;
    if (effectiveZone.includes('R1B')) {
        if (lotAreaFt2 < 43560.0) {
            mfa = (lotAreaFt2 * 0.165) + 1500.0;
            mfa = Math.max(mfa, 2250.0);
        } else {
            mfa = lotAreaFt2 * 0.18;
        }
    } else {
        if (lotAreaFt2 < 43560.0) {
            mfa = (lotAreaFt2 * 0.163) + 726.0;
            mfa = Math.max(mfa, 2250.0);
        } else {
            mfa = lotAreaFt2 * 0.18;
        }
    }
    const mda = lotAreaFt2 * 0.40; // 40% lot coverage
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        mda_label: "Maximum Building Footprint",
        mfa_label: "Maximum Floor Area",
        slopeApplies: slopePercent > 10.0,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: (mfa / lotAreaFt2),
        formulaTooltip: effectiveZone.includes('R1B')
            ? 'Atherton R-1B: Floor Area = (Lot size * 0.165) + 1,500 sq ft (min 2,250 sq ft)'
            : 'Atherton R-1A: Floor Area = (Lot size * 0.163) + 726 sq ft (min 2,250 sq ft)'
    };
};

/**
 * Woodside Calculation Wrapper
 */
export const calculateWoodside = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    
    // Max Main Residence size (Without Exception): 10% of lot area + 1,000 sq ft, capped at 3,000 sq ft.
    const maxResNoException = Math.min(0.10 * lotAreaFt2 + 1000.0, 3000.0);
    
    // Max Main Residence size (With Exception): 5,217 * (Acres - 0.458) + 3,000 sq ft, capped at 4,000 sq ft (for lots > 0.458 acres).
    let maxResWithException = maxResNoException;
    if (lotAreaAcres > 0.458) {
        maxResWithException = Math.min(5217.0 * (lotAreaAcres - 0.458) + 3000.0, 4000.0);
        maxResWithException = Math.max(maxResWithException, maxResNoException);
    }
    
    // TFA = 1.4 * max residence size without exception
    const tfa = 1.4 * maxResNoException;
    
    // MA (Paved Area Limit) = 1.2 * max residence size without exception
    const mda = 1.2 * maxResNoException;

    // Calculate Natural State percentage based on slope
    let natStatePct = 0.0;
    if (slopePercent >= 12.5) {
        if (slopePercent < 15.0) {
            natStatePct = 12.5;
        } else if (slopePercent < 17.5) {
            natStatePct = 40.0;
        } else if (slopePercent < 20.0) {
            natStatePct = 47.5;
        } else if (slopePercent < 22.5) {
            natStatePct = 55.0;
        } else if (slopePercent < 25.0) {
            natStatePct = 62.5;
        } else if (slopePercent < 27.5) {
            natStatePct = 70.0;
        } else if (slopePercent < 30.0) {
            natStatePct = 77.5;
        } else if (slopePercent < 32.5) {
            natStatePct = 85.0;
        } else if (slopePercent < 35.0) {
            natStatePct = 92.5;
        } else {
            natStatePct = 100.0;
        }
    }

    const slopeApplies = slopePercent >= 12.5;
    
    let tooltip = `Woodside R-1:\n`;
    tooltip += `- Max Main Residence (Without Exception): ${Math.round(maxResNoException).toLocaleString()} sq ft\n`;
    if (lotAreaAcres > 0.458) {
        tooltip += `- Max Main Residence (With Exception): ${Math.round(maxResWithException).toLocaleString()} sq ft\n`;
    } else {
        tooltip += `- Max Main Residence (With Exception): Not eligible (lot size <= 0.458 acres)\n`;
    }
    tooltip += `- Total Allowable Floor Area (TFA): 1.4x = ${Math.round(tfa).toLocaleString()} sq ft\n`;
    tooltip += `- Maximum Paved Area & Coverage (MA): 1.2x = ${Math.round(mda).toLocaleString()} sq ft`;
    
    if (slopeApplies) {
        tooltip += `\n- Natural State Required: ${natStatePct}% (slope is ${slopePercent.toFixed(1)}%)`;
        if (lotAreaAcres < 1.0) {
            tooltip += ` (Exempt if developed lot < 1 acre)`;
        }
    }

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(maxResWithException * 10) / 10,
        tfa: Math.round(tfa * 10) / 10,
        slopeApplies: slopeApplies,
        slopePercent,
        natStatePct,
        formulaLabel: 'TFA/MA',
        formulaValue: (maxResWithException / lotAreaFt2),
        formulaTooltip: tooltip
    };
};

/**
 * Orinda Calculation Wrapper
 */
export const calculateOrinda = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let mfa;
    if (lotAreaFt2 >= 20000.0) {
        mfa = Math.min(lotAreaFt2 * 0.20, 7000.0);
    } else if (lotAreaFt2 < 5200.0) {
        mfa = 1400.0;
    } else {
        mfa = 1400.0 + (lotAreaFt2 - 5200.0) * ((4000.0 - 1400.0) / (20000.0 - 5200.0));
    }
    const mda = lotAreaFt2 * 0.25;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: lotAreaFt2 < 20000.0,
        slopePercent,
        formulaLabel: 'Sliding',
        formulaValue: (mfa / lotAreaFt2),
        formulaTooltip: 'Orinda: Sliding scale based on lot size.'
    };
};

/**
 * Lafayette Calculation Wrapper
 */
export const calculateLafayette = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const mda = lotAreaFt2 * 0.30;
    const mfa = lotAreaFt2 * 0.40;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 20.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Lafayette: 30% Coverage, 40% informational FAR.'
    };
};

/**
 * Mountain View Calculation Wrapper
 */
export const calculateMountainView = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let is_restricted = slopePercent > 10.0;
    let saf = 1.0;
    if (slopePercent > 10.0) {
        saf = Math.max(0.5, 1.0 - (0.015 * (slopePercent - 10.0)));
    }

    let far;
    if (lotAreaFt2 <= 5000) {
        far = 0.45;
    } else if (lotAreaFt2 < 10000) {
        far = 0.50 - (0.00001 * lotAreaFt2);
    } else {
        far = 0.40;
    }

    const mfa = lotAreaFt2 * far * saf;
    const mda = lotAreaFt2 * 0.40 * saf;

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_restricted,
        slopePercent,
        formulaLabel: is_restricted ? 'SAF' : 'FAR',
        formulaValue: is_restricted ? saf : far,
        formulaTooltip: 'Mountain View: Tiered FAR. Hillside reduction (SAF) applies if slope > 10%.'
    };
};

/**
 * Sunnyvale Calculation Wrapper
 */
export const calculateSunnyvale = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let is_restricted = slopePercent > 10.0;
    let saf = 1.0;
    if (slopePercent > 20.0) {
        saf = Math.max(0.7, 1.0 - (0.01 * (slopePercent - 20.0)));
    }

    const mfa = lotAreaFt2 * 0.45 * saf;
    const mda = lotAreaFt2 * 0.45 * saf;

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_restricted,
        slopePercent,
        formulaLabel: slopePercent > 20.0 ? 'SAF' : 'FAR',
        formulaValue: slopePercent > 20.0 ? saf : 0.45,
        formulaTooltip: 'Sunnyvale: 45% FAR. Hillside review > 10%, reduction (SAF) > 20%.'
    };
};

/**
 * Santa Clara Calculation Wrapper
 */
export const calculateSantaClara = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let is_restricted = slopePercent >= 15.0;
    let saf = 1.0;
    if (slopePercent >= 15.0) {
        saf = Math.max(0.4, 0.90 - (0.02 * (slopePercent - 15.0)));
    }

    const mfa = lotAreaFt2 * 0.45 * saf;
    const mda = lotAreaFt2 * 0.40 * saf;

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_restricted,
        slopePercent,
        formulaLabel: is_restricted ? 'SAF' : 'FAR',
        formulaValue: is_restricted ? saf : 0.45,
        formulaTooltip: 'Santa Clara: 45% FAR, 40% MDA. Hillside reduction (SAF) >= 15%.'
    };
};

/**
 * Milpitas Calculation Wrapper
 */
export const calculateMilpitas = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let is_hillside = slopePercent >= 10.0;

    // Milpitas Base R1: 45% FAR, 40% Coverage (No SAF reduction on existing lots)
    const mfa = lotAreaFt2 * 0.45;
    const mda = lotAreaFt2 * 0.40;

    let formulaTooltip = 'Milpitas R1: 45% FAR, 40% Coverage.';
    if (is_hillside) {
        // Calculate min acres per du for info
        let minAcres;
        if (slopePercent <= 10.0) minAcres = 10.0;
        else if (slopePercent >= 50.0) minAcres = 80.0;
        else {
            const t = (slopePercent - 10.0) / (50.0 - 10.0);
            minAcres = 10.0 * Math.pow(10, t * Math.log10(80.0 / 10.0));
        }
        formulaTooltip += ` Hillside "H" active. Min land per DU: ${minAcres.toFixed(2)} acres.`;
    }

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_hillside,
        slopePercent,
        formulaLabel: 'R1 Base',
        formulaValue: 0.45,
        formulaTooltip: formulaTooltip
    };
};

/**
 * Marin County Calculation Wrapper
 * Provides a regional baseline for Marin County cities.
 */
export const calculateMarin = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    
    // Baseline: 35% Coverage, 40% FAR
    let mda = lotAreaFt2 * 0.35;
    let mfa = lotAreaFt2 * 0.40;
    
    const is_hillside = slopePercent >= 15.0;
    
    // Simple slope penalty for hillside lots (1% reduction per 1% slope > 15%)
    if (is_hillside) {
        const penalty = Math.min(0.5, (slopePercent - 15.0) * 0.01);
        mda *= (1.0 - penalty);
        mfa *= (1.0 - penalty);
    }
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_hillside,
        slopePercent,
        formulaLabel: is_hillside ? 'Hillside' : 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Marin Baseline: 35% Coverage, 40% FAR. Hillside reduction applies if slope >= 15%.'
    };
};

// ============================================
// MARIN COUNTY CALCULATIONS
// ============================================

export const calculateBelvedere = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let mfa = lotAreaFt2 * 0.35;
    let mda = lotAreaFt2 * 0.30;
    
    let reduction = 1.0;
    if (slopePercent >= 40.0) reduction = 0.50;
    else if (slopePercent >= 25.0) reduction = 0.75;
    
    mfa *= reduction;
    mda *= reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: slopePercent >= 25.0 ? 'Hillside Reduction' : 'Baseline',
        formulaValue: 0.35,
        formulaTooltip: 'Belvedere: 35% FAR, 30% Coverage. Significant reductions for slopes > 25%.'
    };
};

export const calculateCorteMadera = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let pruningFactor = 1.0;
    if (slopePercent >= 40.0) pruningFactor = 0.50;
    else if (slopePercent >= 25.0) pruningFactor = 0.85;
    
    const effectiveArea = lotAreaFt2 * pruningFactor;
    const mfa = effectiveArea * 0.35;
    const mda = effectiveArea * 0.30;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: slopePercent >= 25.0 ? 'Pruned Area' : 'Baseline',
        formulaValue: 0.35,
        formulaTooltip: 'Corte Madera: Steep land (>25%) is excluded from lot area before FAR is applied.'
    };
};

export const calculateFairfax = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const effectiveFar = Math.max(0.05, 0.35 - (slopePercent * 0.005));
    const mfa = lotAreaFt2 * effectiveFar;
    const mda = lotAreaFt2 * 0.30;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: true,
        slopePercent,
        formulaLabel: 'Continuous Slope',
        formulaValue: effectiveFar,
        formulaTooltip: `Fairfax: FAR decreases linearly by 0.5% for every 1% of slope (Current: ${Math.round(effectiveFar * 1000) / 10}%).`
    };
};

export const calculateLarkspur = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let effectiveFar = 0.40;
    if (slopePercent > 10.0) {
        effectiveFar = Math.max(0.10, 0.40 * (1.0 - (slopePercent - 10.0) * 0.01));
    }
    const mfa = lotAreaFt2 * effectiveFar;
    const mda = lotAreaFt2 * 0.40;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: slopePercent > 10 ? 'Slope Penalty' : 'Baseline',
        formulaValue: effectiveFar,
        formulaTooltip: 'Larkspur: 1:1 Slope Penalty (1% FAR reduction per 1% slope > 10%).'
    };
};

export const calculateMillValley = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let mfaBase;
    if (lotAreaFt2 <= 5000) mfaBase = lotAreaFt2 * 0.35;
    else if (lotAreaFt2 <= 10000) mfaBase = 1750.0 + (lotAreaFt2 - 5000) * 0.15;
    else if (lotAreaFt2 <= 20000) mfaBase = 2500.0 + (lotAreaFt2 - 10000) * 0.10;
    else mfaBase = 3500.0 + (lotAreaFt2 - 20000) * 0.05;
    
    let reduction = 1.0;
    if (slopePercent >= 40.0) reduction = 0.50;
    else if (slopePercent >= 25.0) reduction = 0.80;
    
    const mfa = mfaBase * reduction;
    const mda = lotAreaFt2 * 0.35 * reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'MAFA Step-Down',
        formulaValue: Math.round((mfa / lotAreaFt2) * 100) / 100,
        formulaTooltip: 'Mill Valley: MAFA Step-Down reduces intensity as lot size increases. Steep land is excluded.'
    };
};

export const calculateNovato = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let reduction = 1.0;
    if (slopePercent >= 10.0) {
        reduction = Math.max(0.40, 1.0 - (slopePercent - 10.0) * 0.0125);
    }
    const mfa = lotAreaFt2 * 0.40 * reduction;
    const mda = lotAreaFt2 * 0.30 * reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: slopePercent >= 10 ? 'Hillside Guideline' : 'Baseline',
        formulaValue: 0.40 * reduction,
        formulaTooltip: 'Novato: 1.25% reduction for every 1% of slope above 10%.'
    };
};

export const calculateRoss = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const baseFar = Math.max(0.05, 0.20 - (lotAreaAcres * 0.005));
    const slopePenaltyFactor = Math.max(0.20, 1.0 - (slopePercent * 0.002));
    
    const mfa = lotAreaFt2 * baseFar * slopePenaltyFactor;
    const mda = lotAreaFt2 * 0.20 * slopePenaltyFactor;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 20.0,
        slopePercent,
        formulaLabel: 'Ross Quadratic',
        formulaValue: Math.round(baseFar * slopePenaltyFactor * 1000) / 1000,
        formulaTooltip: 'Ross: Intensity drops based on both lot size (Quadratic Scale) and gradient (0.002S Penalty).'
    };
};

export const calculateSanAnselmo = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let reduction = 1.0;
    if (slopePercent >= 25.0) reduction = 0.60;
    else if (slopePercent >= 10.0) reduction = 0.85;
    
    const mfa = lotAreaFt2 * 0.35 * reduction;
    const mda = lotAreaFt2 * 0.30 * reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: slopePercent >= 10 ? 'Hillside Step' : 'Baseline',
        formulaValue: 0.35 * reduction,
        formulaTooltip: 'San Anselmo: 35% FAR base with significant tiered reductions for slopes > 10%.'
    };
};

export const calculateSanRafael = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let reduction = 1.0;
    if (slopePercent >= 40.0) reduction = 0.50;
    else if (slopePercent >= 25.0) reduction = 0.70;
    
    const mfa = lotAreaFt2 * 0.40 * reduction;
    const mda = lotAreaFt2 * 0.30 * reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 25.0,
        slopePercent,
        formulaLabel: slopePercent >= 25 ? 'Natural State' : 'Baseline',
        formulaValue: 0.40 * reduction,
        formulaTooltip: 'San Rafael: 50% Natural State rule applies on steep slopes (>25%), reducing buildable area.'
    };
};

export const calculateSausalito = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let reduction = 1.0;
    if (slopePercent >= 30.0) reduction = 0.50;
    else if (slopePercent >= 15.0) reduction = 0.80;
    
    const mfa = lotAreaFt2 * 0.40 * reduction;
    const mda = lotAreaFt2 * 0.35 * reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: slopePercent >= 15 ? 'Neighborhood Relative' : 'Baseline',
        formulaValue: 0.40 * reduction,
        formulaTooltip: 'Sausalito: Hillside review and sliding scale reductions apply for gradients > 15%.'
    };
};

export const calculateTiburon = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let fagBase;
    if (lotAreaFt2 <= 7500) fagBase = lotAreaFt2 * 0.40;
    else if (lotAreaFt2 <= 15000) fagBase = 3000.0 + (lotAreaFt2 - 7500.0) * 0.20;
    else {
        fagBase = 4500.0 + (lotAreaFt2 - 15000.0) * 0.10;
        fagBase = Math.min(fagBase, 8000.0);
    }
    
    let slopeReduction = 1.0;
    if (slopePercent > 10.0) {
        slopeReduction = Math.max(0.40, 1.0 - (slopePercent - 10.0) * 0.015);
    }
    
    const mfa = fagBase * slopeReduction;
    const mda = lotAreaFt2 * 0.30 * slopeReduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 20.0,
        slopePercent,
        formulaLabel: 'FAG Curve',
        formulaValue: Math.round((mfa / lotAreaFt2) * 100) / 100,
        formulaTooltip: 'Tiburon: Floor Area Guideline (FAG) uses a sliding scale curve with a Slope Coefficient reduction.'
    };
};

// ============================================
// NAPA COUNTY CALCULATIONS
// ============================================

export const calculateAmericanCanyon = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.45 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.45,
        formulaTooltip: 'American Canyon: 45% FAR, 40% Coverage. Hillside review triggers at 15%.'
    };
};

export const calculateCalistoga = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.35,
        formulaTooltip: 'Calistoga: 35% FAR, 35% Coverage. Geothermal resources may restrict subterranean building.'
    };
};

export const calculateNapaCity = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const barrier = slopePercent > 30.0;
    const reduction = slopePercent > 15.0 ? 0.50 : 1.0;
    
    const mfa = barrier ? 0 : lotAreaFt2 * 0.40 * reduction;
    const mda = barrier ? 0 : lotAreaFt2 * 0.35 * reduction;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: barrier ? 'Zero Density' : (slopePercent > 15 ? 'Rural Reduction' : 'Baseline'),
        formulaValue: barrier ? 0 : 0.40 * reduction,
        formulaTooltip: 'Napa City: Zero density assigned to slopes > 30%. 50% reduction for slopes 15-30%.'
    };
};

export const calculateStHelena = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'St. Helena: 40% FAR, 35% Coverage. Hillside review triggers at 10% slope.'
    };
};

export const calculateYountville = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let mfa;
    if (lotAreaFt2 > 8000) {
        mfa = (8000 * 0.45) + ((lotAreaFt2 - 8000) * 0.25);
    } else {
        mfa = lotAreaFt2 * 0.45;
    }
    
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Tiered FAR',
        formulaValue: Math.round((mfa / lotAreaFt2) * 100) / 100,
        formulaTooltip: 'Yountville: Tiered FAR (0.45 for first 8,000 sqft, 0.25 for remainder).'
    };
};

/**
 * Provides a regional baseline for Napa County cities.
 */
export const calculateNapaBaseline = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Napa Baseline: 35% Coverage, 40% FAR. Hillside review typically triggers at 15%.'
    };
};

// ============================================
// SOLANO COUNTY CALCULATIONS
// ============================================

export const calculateBenicia = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const baseYield = 4.0;
    let actualYield = baseYield;
    
    if (slopePercent >= 40.0) actualYield = 0.05;
    else if (slopePercent >= 10.0) actualYield = Math.max(0.05, baseYield - (slopePercent * 0.15));
    
    const mfa = (actualYield * lotAreaAcres) * 2500.0;
    const mda = lotAreaFt2 * 0.35;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: 'Progressive Yield',
        formulaValue: Math.round((mfa / lotAreaFt2) * 100) / 100,
        formulaTooltip: `Benicia: Density yield reduces as slope increases (Base: 4.0 du/ac). Current: ${actualYield.toFixed(2)} du/ac.`
    };
};

export const calculateDixon = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Dixon: 40% FAR, 35% Coverage. Ag-Buffer setbacks may apply.'
    };
};

export const calculateFairfield = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let reduction = 1.0;
    if (slopePercent >= 20.0) reduction = 0.50;
    
    return {
        mda: Math.round(lotAreaFt2 * 0.40 * reduction * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.45 * reduction * 10) / 10,
        slopeApplies: slopePercent >= 20.0,
        slopePercent,
        formulaLabel: slopePercent >= 20 ? 'H-Overlay' : 'Baseline',
        formulaValue: 0.45 * reduction,
        formulaTooltip: 'Fairfield: 45% FAR, 40% Coverage. 50% density reduction for slopes > 20%.'
    };
};

export const calculateRioVista = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Rio Vista: 40% FAR, 35% Coverage. Height and bulk restricted relative to levee crown.'
    };
};

export const calculateSuisunCity = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Suisun City: 40% FAR, 35% Coverage. Marsh Buffer setbacks may apply.'
    };
};

export const calculateVacaville = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    let reduction = 1.0;
    if (slopePercent >= 10.0) {
        reduction = Math.max(0.40, 1.0 - (slopePercent - 10.0) * 0.0125);
    }
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * reduction * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * reduction * 10) / 10,
        slopeApplies: slopePercent >= 10.0,
        slopePercent,
        formulaLabel: slopePercent >= 10 ? 'Hillside Ordinance' : 'Baseline',
        formulaValue: 0.40 * reduction,
        formulaTooltip: 'Vacaville: 1.25% reduction for every 1% of slope above 10%.'
    };
};

export const calculateVallejo = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.45 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.45 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.45,
        formulaTooltip: 'Vallejo: 45% FAR, 45% Coverage. Hillside review triggers at 15%.'
    };
};



const CAMPBELL_ZONE_CONFIG = {
    "R-1-6": {
        "max_coverage_pct": 0.40,
        "base_far": 0.45,
    },
    "R-1-8": {
        "max_coverage_pct": 0.35,
        "base_far": 0.45,
    },
    "R-1-9": {
        "max_coverage_pct": 0.35,
        "base_far": 0.45,
    },
    "R-1-10": {
        "max_coverage_pct": 0.35,
        "base_far": 0.45,
    },
    "R-1-16": {
        "max_coverage_pct": 0.35,
        "base_far": 0.45,
    },
};

/**
 * Campbell Calculation Wrapper
 */
export const calculateCampbell = (slopePercent, lotAreaAcres, zoneCode = "R-1-8") => {
    const cfg = CAMPBELL_ZONE_CONFIG[zoneCode] || CAMPBELL_ZONE_CONFIG["R-1-8"];
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    
    // Campbell Base: Coverage and FAR vary by sub-zone
    const mda_raw = lotAreaFt2 * cfg.max_coverage_pct;
    let mfa_raw = lotAreaFt2 * cfg.base_far;

    let hardCapApplied = false;
    // Hard cap: lots 8,000–8,999 sq ft cannot exceed 4,000 sq ft
    if (lotAreaFt2 >= 8000 && lotAreaFt2 <= 8999) {
        if (mfa_raw > 4000) {
            mfa_raw = 4000;
            hardCapApplied = true;
        }
    }

    let formulaTooltip = `Campbell ${zoneCode}: FAR ${cfg.base_far * 100}%, Coverage ${cfg.max_coverage_pct * 100}%.`;
    if (hardCapApplied) {
        formulaTooltip += " Hard cap of 4,000 sq ft applied (lot area 8k-9k sq ft).";
    }

    return {
        mda: Math.round(mda_raw * 10) / 10,
        mfa: Math.round(mfa_raw * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'STANP Base',
        formulaValue: mfa_raw, // Return sq ft, handle conversion in getZoningMetric
        formulaTooltip: formulaTooltip
    };
};

const GILROY_ZONE_CONFIG = {
    "R-1-8": {
        "max_coverage_pct": 0.40,
        "base_floor_area_1story": 3300,
        "base_floor_area_2story": 3000,
        "base_lot_threshold_ft2": 10000,
        "bonus_per_sqft": 0.15,
        "max_floor_area": 20000,
    },
    "R-1-20": {
        "max_coverage_pct": 0.30,
        "base_floor_area_1story": 4950,
        "base_floor_area_2story": 4500,
        "base_lot_threshold_ft2": 24000,
        "bonus_per_sqft": 0.050,
        "max_floor_area": 20000,
    },
    "R-1-44": {
        "max_coverage_pct": 0.20,
        "base_floor_area_1story": 6600,
        "base_floor_area_2story": 6000,
        "base_lot_threshold_ft2": 44000,
        "bonus_per_sqft": 0.075,
        "max_floor_area": 20000,
    },
};

const GILROY_HILLSIDE_SLOPE_DENSITY = [
    { threshold: 10, du: 4.0 },
    { threshold: 15, du: 3.0 },
    { threshold: 20, du: 2.0 },
    { threshold: 25, du: 1.5 },
    { threshold: 30, du: 1.0 },
    { threshold: Infinity, du: 0.0 },
];

/**
 * Gilroy Calculation Wrapper
 */
export const calculateGilroy = (slopePercent, lotAreaAcres, zoneCode = "R-1-8", stories = 1) => {
    const cfg = GILROY_ZONE_CONFIG[zoneCode] || GILROY_ZONE_CONFIG["R-1-8"];
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    const is_hillside = slopePercent >= 10.0;

    // MDA: Max Development Area (lot coverage)
    let mda = lotAreaFt2 * cfg.max_coverage_pct;
    mda = Math.min(mda, cfg.max_floor_area);

    // MFA: Max Floor Area
    const base_fa = stories === 1 ? cfg.base_floor_area_1story : cfg.base_floor_area_2story;
    const bonus = Math.max(0.0, (lotAreaFt2 - cfg.base_lot_threshold_ft2)) * cfg.bonus_per_sqft;
    let mfa = base_fa + bonus;
    mfa = Math.min(mfa, cfg.max_floor_area);

    let formulaTooltip = `Gilroy ${zoneCode}: Base ${base_fa} + bonus of ${cfg.bonus_per_sqft} per sq ft over ${cfg.base_lot_threshold_ft2}.`;
    let formulaLabel = 'Table FA';

    if (is_hillside) {
        const hillside_du = GILROY_HILLSIDE_SLOPE_DENSITY.find(d => slopePercent <= d.threshold)?.du || 0.0;
        formulaTooltip += ` Hillside active (max ${hillside_du} du/ac).`;
        if (slopePercent > 30.0) {
            mda = 0;
            mfa = 0;
            formulaTooltip = "Slope >30%: No development permitted per Gilroy General Plan.";
        }
    }

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_hillside,
        slopePercent,
        formulaLabel: formulaLabel,
        formulaValue: mfa, // Return sq ft, handle conversion in getZoningMetric
        formulaTooltip: formulaTooltip
    };
};

const MORGAN_HILL_ZONE_CONFIG = {
    "R1-7000": {
        "max_coverage_pct": 0.40,
        "max_far": 0.45,
    },
    "R1-12000": {
        "max_coverage_pct": 0.35,
        "max_far": 0.40,
    },
    "R1-20000": {
        "max_coverage_pct": 0.25,
        "max_far": 0.35,
    },
};

/**
 * Morgan Hill Calculation Wrapper
 */
export const calculateMorganHill = (slopePercent, lotAreaAcres, zoneCode = "R1-7000") => {
    const cfg = MORGAN_HILL_ZONE_CONFIG[zoneCode] || MORGAN_HILL_ZONE_CONFIG["R1-7000"];
    const totalAreaFt2 = lotAreaAcres * 43560.0;
    const is_hillside = slopePercent >= 10.0;
    const in_hcd = slopePercent >= 20.0;

    // Estimate buildable area (portions < 20% slope)
    // Default to 1.0 (all usable) if avg slope < 20%
    // If avg slope >= 20%, we assume 0 buildable without survey data
    let flatFraction = 1.0;
    if (in_hcd) {
        flatFraction = 0.0;
    }
    
    const buildableFt2 = totalAreaFt2 * flatFraction;

    // MDA/MFA applied to buildable area only
    const mda = buildableFt2 * cfg.max_coverage_pct;
    const mfa = buildableFt2 * cfg.max_far;

    let formulaTooltip = `Morgan Hill ${zoneCode}: MDA ${cfg.max_coverage_pct * 100}%, MFA ${cfg.max_far * 100}% of buildable area.`;
    if (in_hcd) {
        formulaTooltip = "Average slope >= 20%: Development prohibited unless survey proves buildable areas exist.";
    } else if (is_hillside) {
        formulaTooltip += " Hillside property status (slope >= 10%). Design Permit/Geo Survey required.";
    }

    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: is_hillside,
        slopePercent,
        formulaLabel: 'Area Based',
        formulaValue: mfa, // Return sq ft, handle conversion in getZoningMetric
        formulaTooltip: formulaTooltip
    };
};
/**
 * Centralized helper to get zoning metric with conversion to acres
 */
/**
 * Internal helper to apply the Tapered Alameda Model for MDA/MFA
 * Used by Alameda, Berkeley, Hayward, Livermore, and others.
 * 
 * @param {number} lotAreaSqFt - Total lot area in sq ft
 * @param {number} slopePercent - Average slope percentage
 * @returns {Object} { mdaRate, mfaRate, slopeReduction }
 */
const applyTaperedAlamedaModel = (lotAreaSqFt, slopePercent) => {
    // 1. Tapered MDA (Lot Coverage)
    let mdaRate = 0.20;
    if (lotAreaSqFt < 10000) mdaRate = 0.40;
    else if (lotAreaSqFt < 20000) mdaRate = 0.30;
    else if (lotAreaSqFt < 43560) mdaRate = 0.25;
    
    // 2. Tapered MFA (Floor Area Ratio)
    let mfaRate = 0.30;
    if (lotAreaSqFt < 5000) mfaRate = 0.50;
    else if (lotAreaSqFt < 12000) mfaRate = 0.45;
    else if (lotAreaSqFt < 25000) mfaRate = 0.40;
    else if (lotAreaSqFt < 43560) mfaRate = 0.35;
    
    // 3. Hillside Slope Reduction (subtractive to MFA rate)
    let slopeReduction = 0.0;
    if (slopePercent > 15.0) {
        slopeReduction = (slopePercent - 15.0) * 0.005;
        mfaRate = Math.max(mfaRate - slopeReduction, 0.10);
    }
    
    return { mdaRate, mfaRate, slopeReduction };
};

export const getZoningMetric = (jurisdiction, slope, acres, zoneCode = "R1") => {
    let calc = null;
    
    // Resolve calculation based on jurisdiction
    if (jurisdiction === 'palo_alto') calc = calculatePaloAlto(slope, acres);
    else if (jurisdiction === 'los_altos_hills') calc = calculateLAH(slope, acres);
    else if (jurisdiction === 'los_altos') calc = calculateLosAltos(slope, acres, zoneCode);
    else if (jurisdiction === 'saratoga') calc = calculateSaratoga(slope, acres);
    else if (jurisdiction === 'los_gatos') calc = calculateLosGatos(slope, acres, zoneCode);
    else if (jurisdiction === 'monte_sereno') calc = calculateMonteSereno(slope, acres);
    else if (jurisdiction === 'cupertino') calc = calculateCupertino(slope, acres, "R1");
    else if (jurisdiction === 'cupertino_hillside') calc = calculateCupertino(slope, acres, "RHS");
    else if (jurisdiction === 'san_jose') calc = calculateSanJose(slope, acres);
    else if (jurisdiction === 'fremont') calc = calculateFremont(slope, acres);
    else if (jurisdiction === 'hillsborough') calc = calculateHillsborough(slope, acres);
    else if (jurisdiction === 'atherton') calc = calculateAtherton(slope, acres, zoneCode);
    else if (jurisdiction === 'woodside') calc = calculateWoodside(slope, acres);
    else if (jurisdiction === 'redwood_city') calc = calculateRedwoodCity(slope, acres);
    else if (jurisdiction === 'san_mateo') calc = calculateSanMateo(slope, acres);
    else if (jurisdiction === 'daly_city') calc = calculateDalyCity(slope, acres);
    else if (jurisdiction === 'south_san_francisco') calc = calculateSouthSanFrancisco(slope, acres);
    else if (jurisdiction === 'foster_city') calc = calculateFosterCity(slope, acres);
    else if (jurisdiction === 'burlingame') calc = calculateBurlingame(slope, acres);
    else if (jurisdiction === 'belmont') calc = calculateBelmont(slope, acres);
    else if (jurisdiction === 'san_carlos') calc = calculateSanCarlos(slope, acres);
    else if (jurisdiction === 'menlo_park') calc = calculateMenloPark(slope, acres);
    else if (jurisdiction === 'millbrae') calc = calculateMillbrae(slope, acres);
    else if (jurisdiction === 'pacifica') calc = calculatePacifica(slope, acres);
    else if (jurisdiction === 'half_moon_bay') calc = calculateHalfMoonBay(slope, acres);
    else if (jurisdiction === 'orinda') calc = calculateOrinda(slope, acres);
    else if (jurisdiction === 'lafayette') calc = calculateLafayette(slope, acres);
    else if (jurisdiction === 'walnut_creek') calc = calculateWalnutCreek(slope, acres);
    else if (jurisdiction === 'concord') calc = calculateConcord(slope, acres);
    else if (jurisdiction === 'richmond') calc = calculateRichmond(slope, acres);
    else if (jurisdiction === 'antioch') calc = calculateAntioch(slope, acres);
    else if (jurisdiction === 'brentwood') calc = calculateBrentwood(slope, acres);
    else if (jurisdiction === 'pittsburg') calc = calculatePittsburg(slope, acres);
    else if (jurisdiction === 'san_ramon') calc = calculateSanRamon(slope, acres);
    else if (jurisdiction === 'pleasant_hill') calc = calculatePleasantHill(slope, acres);
    else if (jurisdiction === 'martinez') calc = calculateMartinez(slope, acres);
    else if (jurisdiction === 'el_cerrito') calc = calculateElCerrito(slope, acres);
    else if (jurisdiction === 'hercules') calc = calculateHercules(slope, acres);
    else if (jurisdiction === 'pinole') calc = calculatePinole(slope, acres);
    else if (jurisdiction === 'clayton') calc = calculateClayton(slope, acres);
    else if (jurisdiction === 'moraga') calc = calculateMoraga(slope, acres);
    else if (jurisdiction === 'danville') calc = calculateDanville(slope, acres);
    else if (jurisdiction === 'alamo') calc = calculateAlamo(slope, acres);
    else if (jurisdiction === 'mountain_view') calc = calculateMountainView(slope, acres);
    else if (jurisdiction === 'sunnyvale') calc = calculateSunnyvale(slope, acres);
    else if (jurisdiction === 'santa_clara') calc = calculateSantaClara(slope, acres);
    else if (jurisdiction === 'milpitas') calc = calculateMilpitas(slope, acres);
    else if (jurisdiction === 'campbell') calc = calculateCampbell(slope, acres, zoneCode);
    else if (jurisdiction === 'gilroy') calc = calculateGilroy(slope, acres, zoneCode);
    else if (jurisdiction === 'morgan_hill') calc = calculateMorganHill(slope, acres, zoneCode);
    else if (jurisdiction === 'oakland') calc = calculateOakland(slope, acres);
    else if (jurisdiction === 'alameda') calc = calculateAlameda(slope, acres);
    else if (jurisdiction === 'berkeley') calc = calculateBerkeley(slope, acres);
    else if (jurisdiction === 'hayward') calc = calculateHayward(slope, acres);
    else if (jurisdiction === 'livermore') calc = calculateLivermore(slope, acres);
    else if (jurisdiction === 'pleasanton') calc = calculatePleasanton(slope, acres);
    else if (jurisdiction === 'dublin') calc = calculateDublin(slope, acres);
    else if (jurisdiction === 'newark') calc = calculateNewark(slope, acres);
    else if (jurisdiction === 'union_city') calc = calculateUnionCity(slope, acres);
    else if (jurisdiction === 'san_leandro') calc = calculateSanLeandro(slope, acres);
    else if (jurisdiction === 'emeryville') calc = calculateEmeryville(slope, acres);
    else if (jurisdiction === 'albany') calc = calculateAlbany(slope, acres);
    else if (jurisdiction === 'piedmont') calc = calculatePiedmont(slope, acres);
    
    // MARIN COUNTY
    else if (jurisdiction === 'belvedere') calc = calculateBelvedere(slope, acres);
    else if (jurisdiction === 'corte_madera') calc = calculateCorteMadera(slope, acres);
    else if (jurisdiction === 'fairfax') calc = calculateFairfax(slope, acres);
    else if (jurisdiction === 'larkspur') calc = calculateLarkspur(slope, acres);
    else if (jurisdiction === 'mill_valley') calc = calculateMillValley(slope, acres);
    else if (jurisdiction === 'novato') calc = calculateNovato(slope, acres);
    else if (jurisdiction === 'ross') calc = calculateRoss(slope, acres);
    else if (jurisdiction === 'san_anselmo') calc = calculateSanAnselmo(slope, acres);
    else if (jurisdiction === 'san_rafael') calc = calculateSanRafael(slope, acres);
    else if (jurisdiction === 'sausalito') calc = calculateSausalito(slope, acres);
    else if (jurisdiction === 'tiburon') calc = calculateTiburon(slope, acres);
    else if (jurisdiction === 'marin_generic') calc = calculateMarin(slope, acres);
    
    // NAPA COUNTY
    else if (jurisdiction === 'american_canyon') calc = calculateAmericanCanyon(slope, acres);
    else if (jurisdiction === 'calistoga') calc = calculateCalistoga(slope, acres);
    else if (jurisdiction === 'napa') calc = calculateNapaCity(slope, acres);
    else if (jurisdiction === 'st_helena') calc = calculateStHelena(slope, acres);
    else if (jurisdiction === 'yountville') calc = calculateYountville(slope, acres);
    else if (jurisdiction === 'napa_generic') calc = calculateNapaBaseline(slope, acres);

    // SOLANO COUNTY
    else if (jurisdiction === 'benicia') calc = calculateBenicia(slope, acres);
    else if (jurisdiction === 'dixon') calc = calculateDixon(slope, acres);
    else if (jurisdiction === 'fairfield') calc = calculateFairfield(slope, acres);
    else if (jurisdiction === 'rio_vista') calc = calculateRioVista(slope, acres);
    else if (jurisdiction === 'suisun_city') calc = calculateSuisunCity(slope, acres);
    else if (jurisdiction === 'vacaville') calc = calculateVacaville(slope, acres);
    else if (jurisdiction === 'vallejo') calc = calculateVallejo(slope, acres);
    else if (jurisdiction === 'solano_generic') calc = calculateSolano(slope, acres);
    else if (jurisdiction === 'arnold' || jurisdiction === 'calaveras_generic') calc = calculateArnold(slope, acres, zoneCode);
    else if (jurisdiction === 'frisco') calc = calculateFrisco(slope, acres, zoneCode);
    else if (jurisdiction === 'mckinney') calc = calculateMcKinney(slope, acres, zoneCode);
    else if (jurisdiction === 'oakley') calc = calculateOakley(slope, acres);
    else if (jurisdiction === 'san_pablo') calc = calculateSanPablo(slope, acres);
    else if (jurisdiction === 'portola_valley') calc = calculatePortolaValley(slope, acres);

    if (!calc || !calc.formulaLabel) return null;

    let convertedValue = calc.formulaValue;

    // Conversion logic to ensure everything is in acres
    const ratioBased = [
        'palo_alto', 'los_altos', 'cupertino', 'cupertino_hillside', 
        'san_jose', 'fremont', 'hillsborough', 'atherton', 
        'woodside', 'orinda', 'lafayette', 'mountain_view', 
        'sunnyvale', 'santa_clara', 'milpitas', 'oakland', 'alameda', 'berkeley', 'hayward', 'livermore',
        'pleasanton', 'dublin', 'newark', 'union_city', 'san_leandro', 'emeryville', 'albany', 'piedmont',
        'redwood_city', 'san_mateo', 'daly_city', 'south_san_francisco', 'foster_city',
        'burlingame', 'belmont', 'san_carlos', 'menlo_park', 'millbrae', 'pacifica', 'half_moon_bay',
        'walnut_creek', 'concord', 'richmond', 'antioch', 'brentwood', 'pittsburg', 'san_ramon', 'pleasant_hill',
        'martinez', 'el_cerrito', 'hercules', 'pinole', 'clayton', 'moraga', 'danville', 'alamo',
        'belvedere', 'corte_madera', 'fairfax', 'larkspur', 'mill_valley', 'novato', 'ross', 'san_anselmo', 'san_rafael', 'sausalito', 'tiburon', 'marin_generic',
        'american_canyon', 'calistoga', 'napa', 'st_helena', 'yountville', 'napa_generic',
        'benicia', 'dixon', 'fairfield', 'rio_vista', 'suisun_city', 'vacaville', 'vallejo', 'solano_generic',
        'arnold', 'calaveras_generic', 'oakley', 'san_pablo', 'portola_valley', 'los_gatos', 'frisco', 'mckinney'
    ];

    if (ratioBased.includes(jurisdiction)) {
        // These are ratios (FAR/SAF), so metric in acres = lot area * ratio
        convertedValue = acres * calc.formulaValue;
    } else if (jurisdiction === 'saratoga' || jurisdiction === 'gilroy' || jurisdiction === 'morgan_hill' || jurisdiction === 'campbell') {
        // These are sq ft (NSA/Table FA/Area Based/STANP), so metric in acres = sq ft / 43560
        convertedValue = calc.formulaValue / 43560.0;
    } else if (jurisdiction === 'monte_sereno') {
        // This is percentage (IC%), so metric in acres = lot area * (pct/100)
        convertedValue = acres * (calc.formulaValue / 100.0);
    } else if (jurisdiction === 'piedmont') {
        // Piedmont LUF is effective area in acres
        convertedValue = calc.formulaValue;
    }
    // LAH (LUF) is already returned in acres in its formulaValue

    return {
        ...calc,
        convertedValue: convertedValue
    };
};

/**
 * Oakland building calculations
 */
export const calculateOakland = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // 1. Tapered MDA (Lot Coverage)
    let mdaRate = 0.20;
    if (grossSqFt < 10000) mdaRate = 0.40;
    else if (grossSqFt < 20000) mdaRate = 0.30;
    else if (grossSqFt < 43560) mdaRate = 0.25;
    
    let mda = grossSqFt * mdaRate;
    if (grossSqFt < 5000) mda = Math.max(mda, 2000.0);
    
    // 2. Tapered MFA (Floor Area Ratio)
    let mfaRate = 0.30;
    if (grossSqFt < 5000) mfaRate = 0.55;
    else if (grossSqFt < 12000) mfaRate = 0.50;
    else if (grossSqFt < 25000) mfaRate = 0.45;
    else if (grossSqFt < 43560) mfaRate = 0.35;
    
    let mfa = grossSqFt * mfaRate;
    if (grossSqFt < 5000) mfa = Math.max(mfa, 2000.0);

    // 3. Hillside Slope Reduction (multiplicative to MFA area)
    let slopeReduction = 0.0;
    if (slopePercent > 15.0) {
        slopeReduction = (slopePercent - 15.0) * 0.005;
        mfa = mfa * (1.0 - slopeReduction);
    }
    
    const effectiveFar = grossSqFt > 0 ? mfa / grossSqFt : 0;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent > 20.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: Math.round(effectiveFar * 1000) / 1000,
        formulaTooltip: `Oakland Tapered Model: MDA ${Math.round(mdaRate * 100)}%, Base MFA ${Math.round(mfaRate * 100)}%. ${slopeReduction > 0 ? `Slope reduction of ${Math.round(slopeReduction * 1000) / 10}% applied.` : ''} Hillside review at 20% slope.`
    };
};

/**
 * Alameda building calculations
 */
export const calculateAlameda = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const { mdaRate, mfaRate, slopeReduction } = applyTaperedAlamedaModel(grossSqFt, slopePercent);
    
    const mda = grossSqFt * mdaRate;
    const mfa = grossSqFt * mfaRate;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 5.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: Math.round(mfaRate * 1000) / 1000,
        formulaTooltip: `Alameda Tapered Model: MDA ${Math.round(mdaRate * 100)}%, MFA ${Math.round(mfaRate * 100)}%. ${slopeReduction > 0 ? `(Includes slope reduction of ${Math.round(slopeReduction * 1000) / 10}%).` : ''} Hillside standards at 5.0% slope.`
    };
};

/**
 * Berkeley building calculations
 */
export const calculateBerkeley = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const { mdaRate, mfaRate, slopeReduction } = applyTaperedAlamedaModel(grossSqFt, slopePercent);
    
    const mda = grossSqFt * mdaRate;
    const mfa = grossSqFt * mfaRate;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent > 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: Math.round(mfaRate * 1000) / 1000,
        formulaTooltip: `Berkeley Tapered Model: MDA ${Math.round(mdaRate * 100)}%, MFA ${Math.round(mfaRate * 100)}%. ${slopeReduction > 0 ? `(Includes slope reduction of ${Math.round(slopeReduction * 1000) / 10}%).` : ''} Hillside review at 15.0% slope.`
    };
};

/**
 * Hayward building calculations
 */
export const calculateHayward = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const { mdaRate, mfaRate, slopeReduction } = applyTaperedAlamedaModel(grossSqFt, slopePercent);
    
    const mda = grossSqFt * mdaRate;
    const mfa = grossSqFt * mfaRate;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: Math.round(mfaRate * 1000) / 1000,
        formulaTooltip: `Hayward Tapered Model: MDA ${Math.round(mdaRate * 100)}%, MFA ${Math.round(mfaRate * 100)}%. ${slopeReduction > 0 ? `(Includes slope reduction of ${Math.round(slopeReduction * 1000) / 10}%).` : ''} Hillside triggers at 15% slope.`
    };
};

/**
 * Livermore building calculations
 */
export const calculateLivermore = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const { mdaRate, mfaRate, slopeReduction } = applyTaperedAlamedaModel(grossSqFt, slopePercent);
    
    const mda = grossSqFt * mdaRate;
    const mfa = grossSqFt * mfaRate;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: Math.round(mfaRate * 1000) / 1000,
        formulaTooltip: `Livermore Tapered Model: MDA ${Math.round(mdaRate * 100)}%, MFA ${Math.round(mfaRate * 100)}%. ${slopeReduction > 0 ? `(Includes slope reduction of ${Math.round(slopeReduction * 1000) / 10}%).` : ''} Hillside review at 15% slope.`
    };
};

/**
 * Pleasanton building calculations
 */
export const calculatePleasanton = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Pleasanton: 40% Coverage, 45% FAR. Hillside standards at 15% slope.'
    };
};

/**
 * Dublin building calculations
 */
export const calculateDublin = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35;
    const mfa = grossSqFt * 0.40;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 20.0,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Dublin: 35% Coverage, 40% FAR. Hillside standards at 20% slope.'
    };
};

/**
 * Newark building calculations
 */
export const calculateNewark = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Newark: 40% Coverage, 45% FAR.'
    };
};

/**
 * Union City building calculations
 */
export const calculateUnionCity = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Union City: 40% Coverage, 45% FAR.'
    };
};

/**
 * San Leandro building calculations
 */
export const calculateSanLeandro = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    
    let mfa;
    if (grossSqFt < 8000) {
        mfa = Math.min(4000, (grossSqFt * 0.50) + 500);
    } else {
        const mfa_0_5 = Math.min(grossSqFt, 5000) * 0.50;
        const mfa_5_10 = Math.max(0, Math.min(grossSqFt, 10000) - 5000) * 0.30;
        const mfa_10_plus = Math.max(0, grossSqFt - 10000) * 0.10;
        mfa = mfa_0_5 + mfa_5_10 + mfa_10_plus + 500;
    }
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'Tiered',
        formulaValue: mfa / grossSqFt,
        formulaTooltip: 'San Leandro: Tiered FAR formula based on lot size.'
    };
};

/**
 * Emeryville building calculations
 */
export const calculateEmeryville = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.50;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.50,
        formulaTooltip: 'Emeryville: 40% Coverage, 50% FAR.'
    };
};

/**
 * Albany building calculations
 */
export const calculateAlbany = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.50;
    const mfa = grossSqFt * 0.55;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: false,
        slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.55,
        formulaTooltip: 'Albany: 50% Coverage, 55% FAR.'
    };
};

/**
 * Piedmont building calculations
 */
export const calculatePiedmont = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // Hillside penalty factor
    let penaltyFactor = 1.0;
    if (slopePercent > 6.0) {
        penaltyFactor = 1.0 + 0.02 * (slopePercent - 6.0);
        penaltyFactor = Math.min(1.5, penaltyFactor);
    }
    
    const effectiveAreaSqFt = grossSqFt / penaltyFactor;
    const mda = effectiveAreaSqFt * 0.40;
    const mfa = effectiveAreaSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 16.0,
        slopePercent,
        formulaLabel: 'LUF Area',
        formulaValue: effectiveAreaSqFt / 43560.0,
        formulaTooltip: 'Piedmont: 40% Coverage, 45% FAR on HCD Adjusted Area. Penalty applies > 6% slope.'
    };
};
/**
 * Redwood City Calculations
 */
export const calculateRedwoodCity = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // MFA: 0.40 or 2,500 sq ft, whichever is greater
    const mfa = Math.max(2500.0, grossSqFt * 0.40);
    
    // MDA: 45% standard limit
    const mda = grossSqFt * 0.45;
    
    // Review triggers
    const requiresReview = (mfa > 3000.0) || (mfa / grossSqFt > 0.45) || (slopePercent >= 15.0);
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: requiresReview,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: grossSqFt > 0 ? (mfa / grossSqFt) : 0.40,
        formulaTooltip: 'Redwood City: 40% FAR (min 2,500 sq ft). Review required if MFA > 45% or 3,000 sq ft. Hillside >= 15% slope.'
    };
};

/**
 * San Mateo Calculations
 */
export const calculateSanMateo = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    let mfa;
    if (grossSqFt <= 5000.0) {
        mfa = grossSqFt * 0.5;
    } else {
        mfa = (5000.0 * 0.5) + ((grossSqFt - 5000.0) * 0.25);
    }
    
    const mda = grossSqFt * 0.40;
    const isHillside = slopePercent >= 15.0;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: isHillside,
        slopePercent: slopePercent,
        formulaLabel: 'Tiered',
        formulaValue: grossSqFt > 0 ? (mfa / grossSqFt) : 0.50,
        formulaTooltip: 'San Mateo: 50% for 1st 5,000 sq ft, 25% thereafter. 40% Coverage. Hillside review triggers at 15% slope.'
    };
};

/**
 * Daly City Calculations
 */
export const calculateDalyCity = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    const isHillside = slopePercent >= 15.0;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: isHillside,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Daly City: 40% Coverage, 45% FAR. Hillside review triggers at 15% slope.'
    };
};

/**
 * South San Francisco Calculations
 */
export const calculateSouthSanFrancisco = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    const isHillside = slopePercent >= 15.0;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: isHillside,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'South San Francisco: 40% Coverage, 45% FAR. Hillside review triggers at 15% slope.'
    };
};

/**
 * Foster City Calculations
 */
export const calculateFosterCity = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.45;
    const mfa = grossSqFt * 0.50;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: true, // Always requires review
        slopePercent: slopePercent,
        formulaLabel: 'PD',
        formulaValue: 0.50,
        formulaTooltip: 'Foster City: PD District Review. Baseline estimation: 45% Coverage, 50% FAR. Architectural Review typically required.'
    };
};

/**
 * Burlingame building calculations
 */
export const calculateBurlingame = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // MFA: 45% for first 5,000 sq ft, 25% for 5,000 to 10,000, 15% thereafter
    let mfa;
    if (grossSqFt <= 5000.0) {
        mfa = grossSqFt * 0.45;
    } else if (grossSqFt <= 10000.0) {
        mfa = (5000.0 * 0.45) + ((grossSqFt - 5000.0) * 0.25);
    } else {
        mfa = (5000.0 * 0.45) + (5000.0 * 0.25) + ((grossSqFt - 10000.0) * 0.15);
    }
    
    const mda = grossSqFt * 0.40;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'Tiered',
        formulaValue: grossSqFt > 0 ? (mfa / grossSqFt) : 0.45,
        formulaTooltip: 'Burlingame: 45% for 1st 5,000 sq ft, 25% for next 5,000, 15% thereafter. 40% Coverage.'
    };
};

/**
 * Belmont building calculations
 */
export const calculateBelmont = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // MFA: Based on lot size table for R-1 districts
    let mfa;
    if (grossSqFt <= 10000.0) {
        mfa = Math.min(3500, grossSqFt * 0.50); // Using 50% baseline for small lots
    } else {
        mfa = Math.min(5000, 3500 + (grossSqFt - 10000) * 0.15);
    }
    
    const mda = grossSqFt * 0.40;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'Table 5',
        formulaValue: grossSqFt > 0 ? (mfa / grossSqFt) : 0.35,
        formulaTooltip: 'Belmont: Base 3,500 sq ft for lots up to 10,000 sq ft, plus 15% thereafter, max 5,000 sq ft. Hillside review triggers at 15% slope.'
    };
};

/**
 * San Carlos building calculations
 */
export const calculateSanCarlos = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // MFA: Based on November 2018 changes
    let mfa;
    if (grossSqFt <= 7500.0) {
        mfa = Math.max(1100 + (grossSqFt * 0.35), grossSqFt * 0.50);
    } else {
        mfa = grossSqFt * 0.50;
    }
    
    const mda = grossSqFt * 0.40; // Standard 40% coverage
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'MFA',
        formulaValue: grossSqFt > 0 ? (mfa / grossSqFt) : 0.50,
        formulaTooltip: 'San Carlos: MAX(1,100 + 35%, 50%) for <= 7,500 sq ft; 50% for larger lots. 40% Coverage.'
    };
};

/**
 * Menlo Park building calculations
 */
export const calculateMenloPark = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    
    // Floor Area Limit (FAL)
    let mfa;
    if (grossSqFt < 5000.0) {
        mfa = grossSqFt * 0.45; // Default estimation
    } else if (grossSqFt <= 10500.0) {
        mfa = (0.30 * grossSqFt) + 500;
    } else {
        mfa = Math.min(6000, 3850 + (grossSqFt - 10500) * 0.10);
    }
    
    // Building Coverage (MDA)
    let mda;
    if (grossSqFt <= 7000.0) {
        mda = grossSqFt * 0.40;
    } else if (grossSqFt <= 10500.0) {
        // Linear gradient from 40% at 7,000 down to 35% at 10,500
        const coverageRate = 0.40 - ((grossSqFt - 7000.0) / 3500.0) * 0.05;
        mda = grossSqFt * coverageRate;
    } else {
        mda = grossSqFt * 0.35;
    }
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAL',
        formulaValue: grossSqFt > 0 ? (mfa / grossSqFt) : 0.35,
        formulaTooltip: 'Menlo Park: FAL = 30% + 500 (5k-10.5k); 3,850 + 10% thereafter. Coverage 40% to 35% gradient.'
    };
};

/**
 * Millbrae building calculations
 */
export const calculateMillbrae = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.50;
    const mfa = grossSqFt * 0.55;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent > 30.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.55,
        formulaTooltip: 'Millbrae: 50% Lot Coverage, 55% Floor Area Ratio (FAR). Net Site Area reductions for slopes > 30%.'
    };
};

/**
 * Pacifica building calculations
 */
export const calculatePacifica = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Pacifica: 40% Max Lot Coverage. Baseline estimation: 45% FAR. Hillside review at 15% slope.'
    };
};

/**
 * Half Moon Bay building calculations
 */
export const calculateHalfMoonBay = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35; // Defaulting to 2-story limit (35%)
    const mfa = grossSqFt * 0.50; // 0.5:1 FAR
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.50,
        formulaTooltip: 'Half Moon Bay: 50% FAR (0.5:1). Coverage limit: 50% (1-story) or 35% (2-story). Hillside review at 15% slope.'
    };
};

/**
 * Walnut Creek building calculations
 */
export const calculateWalnutCreek = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35; // Baseline
    const mfa = grossSqFt * 0.40; // Baseline
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Walnut Creek: Baseline estimate (35% Coverage, 40% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Clayton building calculations
 */
export const calculateClayton = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35;
    const mfa = grossSqFt * 0.40;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Clayton: Baseline estimate (35% Coverage, 40% FAR). Hillside review at 15% slope.'
    };
};

/**
 * Moraga building calculations
 */
export const calculateMoraga = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.30;
    const mfa = grossSqFt * 0.40;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Moraga: Baseline estimate (30% Coverage, 40% FAR). Hillside review at 15% slope.'
    };
};

/**
 * Danville building calculations
 */
export const calculateDanville = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35;
    const mfa = grossSqFt * 0.40;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Danville: Baseline estimate (35% Coverage, 40% FAR). Hillside review at 15% slope.'
    };
};

/**
 * Alamo building calculations
 */
export const calculateAlamo = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35;
    const mfa = grossSqFt * 0.40;
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Alamo: Baseline estimate (35% Coverage, 40% FAR). Hillside review at 15% slope.'
    };
};

/**
 * Concord building calculations
 */
export const calculateConcord = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40; 
    const mfa = grossSqFt * 0.45; 
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Concord: Baseline estimate (40% Coverage, 45% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Richmond building calculations
 */
export const calculateRichmond = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Richmond: Baseline estimate (40% Coverage, 45% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Antioch building calculations
 */
export const calculateAntioch = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Antioch: Baseline estimate (40% Coverage, 45% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Brentwood building calculations
 */
export const calculateBrentwood = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Brentwood: Baseline estimate (40% Coverage, 45% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Pittsburg building calculations
 */
export const calculatePittsburg = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Pittsburg: Baseline estimate (40% Coverage, 45% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * San Ramon building calculations
 */
export const calculateSanRamon = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35;
    const mfa = grossSqFt * 0.40;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'San Ramon: Baseline estimate (35% Coverage, 40% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Pleasant Hill building calculations
 */
export const calculatePleasantHill = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40;
    const mfa = grossSqFt * 0.45;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.45,
        formulaTooltip: 'Pleasant Hill: Baseline estimate (40% Coverage, 45% FAR). Hillside review typically at 15% slope.'
    };
};

/**
 * Martinez building calculations
 */
export const calculateMartinez = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.35; // Martinez R-1 typical coverage
    const mfa = grossSqFt * 0.40; // Martinez R-1 typical FAR
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Martinez: Baseline estimate (35% Coverage, 40% FAR). Hillside development standards (Ch 22.34) apply for slopes >= 15%.'
    };
};

/**
 * El Cerrito building calculations
 */
export const calculateElCerrito = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40; // El Cerrito RS typical coverage
    const mfa = grossSqFt * 0.40; // El Cerrito fallback FAR
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'El Cerrito: Baseline estimate (40% Coverage, 40% FAR). RAD review regulates massing via daylight planes.'
    };
};

/**
 * Hercules building calculations
 */
export const calculateHercules = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40; // Hercules RS typical coverage
    const mfa = grossSqFt * 0.40; // Hercules fallback FAR
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Hercules: Baseline estimate (40% Coverage, 40% FAR). Subject to PD requirements if applicable.'
    };
};

/**
 * Pinole building calculations
 */
export const calculatePinole = (slopePercent, lotAreaAcres) => {
    const grossSqFt = lotAreaAcres * 43560.0;
    const mda = grossSqFt * 0.40; // Pinole R-1 typical coverage
    const mfa = grossSqFt * 0.40; // Pinole fallback FAR
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent: slopePercent,
        formulaLabel: 'FAR',
        formulaValue: 0.40,
        formulaTooltip: 'Pinole: Baseline estimate (40% Coverage, 40% FAR). Hillside review triggered at 15% slope.'
    };
};

// ============================================
// OAKLEY, SAN PABLO, PORTOLA VALLEY FORMULAS
// ============================================

export const calculateOakley = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.35 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'Oakley: 40% FAR, 35% Coverage. Agricultural Buffer and Vineyard Sensitivity rules apply.'
    };
};

export const calculateSanPablo = (slopePercent, lotAreaAcres) => {
    const lotAreaFt2 = lotAreaAcres * 43560.0;
    return {
        mda: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        mfa: Math.round(lotAreaFt2 * 0.40 * 10) / 10,
        slopeApplies: slopePercent >= 15.0,
        slopePercent,
        formulaLabel: 'Baseline',
        formulaValue: 0.40,
        formulaTooltip: 'San Pablo: 40% FAR, 40% Coverage. 20-30% Pervious surface requirement.'
    };
};

export const calculatePortolaValley = (slopePercent, lotAreaAcres) => {
    const lotAreaSqft = lotAreaAcres * 43560.0;
    
    // 1. Calculate APA (Adjusted Parcel Area)
    const slopeReductionFactor = Math.max(0, 1.0 - (slopePercent * 0.005));
    const apaSqFt = lotAreaSqft * slopeReductionFactor;
    
    // 2. Calculate MFA from AMFA tiers (Simplified PV formula)
    let mfa;
    if (apaSqFt <= 20000) {
        mfa = apaSqFt * 0.25;
    } else if (apaSqFt <= 43560) {
        mfa = 5000 + (apaSqFt - 20000) * 0.15;
    } else {
        mfa = 8534 + (apaSqFt - 43560) * 0.10;
    }
    
    const mda = apaSqFt * 0.30;
    
    return {
        mda: Math.round(mda * 10) / 10,
        mfa: Math.round(mfa * 10) / 10,
        slopeApplies: true,
        slopePercent,
        apaSqFt: Math.round(apaSqFt * 10) / 10,
        formulaLabel: 'APA',
        formulaValue: slopeReductionFactor,
        formulaTooltip: `Portola Valley: Uses Adjusted Parcel Area (APA) which reduces by 0.5% for every 1% slope. (APA: ${Math.round(apaSqFt).toLocaleString()} sqft)`
    };
};


